export const risingStarData: Record<number, { y2024: number; y2025: number }> = {
  0: { y2024: 0, y2025: 0 },
  1: { y2024: 0, y2025: 0 },
  3: { y2024: 0, y2025: 0 },
  4: { y2024: 4, y2025: 4 },
  6: { y2024: 8, y2025: 7 },
  7: { y2024: 7, y2025: 6 },
  9: { y2024: 13, y2025: 13 },
  10: { y2024: 5, y2025: 5 },
  12: { y2024: 4, y2025: 4 },
  13: { y2024: 3, y2025: 3 },
  14: { y2024: 0, y2025: 0 },
  28: { y2024: 13, y2025: 9 },
  38: { y2024: 1, y2025: 1 },
  39: { y2024: 1, y2025: 1 },
  41: { y2024: 3, y2025: 3 },
  42: { y2024: 9, y2025: 9 },
  43: { y2024: 9, y2025: 7 },
  44: { y2024: 4, y2025: 3 },
  46: { y2024: 13, y2025: 13 },
  49: { y2024: 2, y2025: 2 },
  53: { y2024: 4, y2025: 5 },
  54: { y2024: 1, y2025: 1 },
  56: { y2024: 5, y2025: 5 },
  59: { y2024: 5, y2025: 5 },
  61: { y2024: 3, y2025: 3 },
  65: { y2024: 9, y2025: 9 },
  67: { y2024: 9, y2025: 9 },
  71: { y2024: 13, y2025: 13 },
  78: { y2024: 4, y2025: 5 },
  81: { y2024: 4, y2025: 5 },
  85: { y2024: 2, y2025: 4 },
  87: { y2024: 5, y2025: 5 },
  91: { y2024: 5, y2025: 5 },
  100: { y2024: 1, y2025: 1 },
  103: { y2024: 9, y2025: 9 },
  105: { y2024: 0, y2025: 0 },
  106: { y2024: 3, y2025: 4 },
  111: { y2024: 13, y2025: 9 },
  114: { y2024: 1, y2025: 1 },
  123: { y2024: 7, y2025: 5 },
  127: { y2024: 2, y2025: 2 },
  128: { y2024: 6, y2025: 6 },
  129: { y2024: 13, y2025: 13 },
  132: { y2024: 3, y2025: 3 },
  140: { y2024: 1, y2025: 1 },
  141: { y2024: 2, y2025: 2 },
  142: { y2024: 2, y2025: 3 },
  143: { y2024: 3, y2025: 3 },
  146: { y2024: 4, y2025: 2 },
  147: { y2024: 7, y2025: 6 },
  148: { y2024: 2, y2025: 2 },
  152: { y2024: 5, y2025: 3 },
  153: { y2024: 6, y2025: 6 },
  154: { y2024: 2, y2025: 2 },
  155: { y2024: 1, y2025: 1 },
  159: { y2024: 1, y2025: 1 },
  160: { y2024: 9, y2025: 7 },
  163: { y2024: 4, y2025: 4 },
  165: { y2024: 0, y2025: 0 },
  167: { y2024: 1, y2025: 1 },
  172: { y2024: 4, y2025: 3 },
  175: { y2024: 3, y2025: 3 },
  176: { y2024: 0, y2025: 0 },
  177: { y2024: 5, y2025: 5 },
  178: { y2024: 8, y2025: 5 },
  179: { y2024: 13, y2025: 10 },
  181: { y2024: 3, y2025: 4 },
  186: { y2024: 2, y2025: 2 },
  188: { y2024: 6, y2025: 3 },
  197: { y2024: 9, y2025: 7 },
  198: { y2024: 1, y2025: 1 },
  199: { y2024: 6, y2025: 6 },
  200: { y2024: 7, y2025: 7 },
  201: { y2024: 5, y2025: 5 },
  203: { y2024: 4, y2025: 4 },
  206: { y2024: 13, y2025: 13 },
  210: { y2024: 0, y2025: 0 },
  212: { y2024: 6, y2025: 5 },
  215: { y2024: 2, y2025: 2 },
  217: { y2024: 9, y2025: 9 },
  221: { y2024: 4, y2025: 4 },
  223: { y2024: 4, y2025: 6 },
  225: { y2024: 13, y2025: 13 },
  226: { y2024: 1, y2025: 1 },
  228: { y2024: 1, y2025: 1 },
  229: { y2024: 5, y2025: 5 },
  230: { y2024: 2, y2025: 3 },
  233: { y2024: 1, y2025: 1 },
  241: { y2024: 3, y2025: 2 },
  242: { y2024: 1, y2025: 1 },
  245: { y2024: 9, y2025: 9 },
  248: { y2024: 0, y2025: 0 },
  249: { y2024: 5, y2025: 5 },
  252: { y2024: 2, y2025: 2 },
  254: { y2024: 3, y2025: 3 },
  255: { y2024: 3, y2025: 3 },
  256: { y2024: 7, y2025: 7 },
  258: { y2024: 2, y2025: 2 },
  264: { y2024: 5, y2025: 5 },
  265: { y2024: 1, y2025: 1 },
  267: { y2024: 6, y2025: 5 },
  270: { y2024: 1, y2025: 1 },
  271: { y2024: 13, y2025: 13 },
  272: { y2024: 13, y2025: 13 },
  276: { y2024: 1, y2025: 1 },
  278: { y2024: 4, y2025: 4 },
  280: { y2024: 1, y2025: 1 },
  281: { y2024: 1, y2025: 1 },
  283: { y2024: 3, y2025: 3 },
  289: { y2024: 1, y2025: 1 },
  290: { y2024: 11, y2025: 9 },
  291: { y2024: 1, y2025: 2 },
  293: { y2024: 7, y2025: 6 },
  296: { y2024: 11, y2025: 9 },
  300: { y2024: 13, y2025: 6 },
  302: { y2024: 5, y2025: 4 },
  303: { y2024: 2, y2025: 2 },
  304: { y2024: 4, y2025: 4 },
  308: { y2024: 4, y2025: 3 },
  310: { y2024: 6, y2025: 6 },
  311: { y2024: 8, y2025: 5 },
  314: { y2024: 5, y2025: 5 },
  316: { y2024: 12, y2025: 8 },
  325: { y2024: 2, y2025: 2 },
  329: { y2024: 4, y2025: 4 },
  330: { y2024: 8, y2025: 5 },
  333: { y2024: 1, y2025: 1 },
  337: { y2024: 7, y2025: 6 },
  340: { y2024: 2, y2025: 2 },
  341: { y2024: 3, y2025: 3 },
  343: { y2024: 2, y2025: 2 },
  347: { y2024: 0, y2025: 0 },
  349: { y2024: 13, y2025: 13 },
  351: { y2024: 3, y2025: 3 },
  352: { y2024: 13, y2025: 13 },
  353: { y2024: 13, y2025: 9 },
  354: { y2024: 5, y2025: 5 },
  358: { y2024: 3, y2025: 2 },
  359: { y2024: 5, y2025: 5 },
  360: { y2024: 0, y2025: 0 },
  361: { y2024: 6, y2025: 5 },
  362: { y2024: 9, y2025: 9 },
  363: { y2024: 10, y2025: 7 },
  368: { y2024: 5, y2025: 5 },
  373: { y2024: 0, y2025: 0 },
  374: { y2024: 5, y2025: 5 },
  375: { y2024: 10, y2025: 7 },
  377: { y2024: 11, y2025: 9 },
  378: { y2024: 8, y2025: 5 },
  379: { y2024: 3, y2025: 3 },
  381: { y2024: 12, y2025: 8 },
  382: { y2024: 4, y2025: 5 },
  384: { y2024: 4, y2025: 3 },
  387: { y2024: 0, y2025: 0 },
  388: { y2024: 13, y2025: 13 },
  392: { y2024: 13, y2025: 13 },
  394: { y2024: 3, y2025: 3 },
  397: { y2024: 6, y2025: 7 },
  402: { y2024: 2, y2025: 3 },
  404: { y2024: 3, y2025: 3 },
  406: { y2024: 13, y2025: 9 },
  407: { y2024: 0, y2025: 0 },
  409: { y2024: 3, y2025: 3 },
  412: { y2024: 4, y2025: 4 },
  417: { y2024: 13, y2025: 13 },
  422: { y2024: 4, y2025: 4 },
  423: { y2024: 12, y2025: 8 },
  424: { y2024: 10, y2025: 7 },
  425: { y2024: 8, y2025: 9 },
  428: { y2024: 13, y2025: 9 },
  429: { y2024: 3, y2025: 4 },
  431: { y2024: 5, y2025: 3 },
  433: { y2024: 0, y2025: 0 },
  434: { y2024: 3, y2025: 4 },
  435: { y2024: 3, y2025: 2 },
  439: { y2024: 2, y2025: 2 },
  440: { y2024: 3, y2025: 3 },
  442: { y2024: 1, y2025: 1 },
  446: { y2024: 13, y2025: 13 },
  452: { y2024: 5, y2025: 5 },
  459: { y2024: 3, y2025: 2 },
  460: { y2024: 6, y2025: 5 },
  464: { y2024: 13, y2025: 13 },
  466: { y2024: 2, y2025: 2 },
  468: { y2024: 5, y2025: 5 },
  470: { y2024: 2, y2025: 2 },
  472: { y2024: 5, y2025: 5 },
  474: { y2024: 13, y2025: 13 },
  475: { y2024: 5, y2025: 5 },
  476: { y2024: 0, y2025: 0 },
  477: { y2024: 13, y2025: 13 },
  478: { y2024: 13, y2025: 13 },
  479: { y2024: 7, y2025: 5 },
  480: { y2024: 4, y2025: 4 },
  481: { y2024: 1, y2025: 1 },
  482: { y2024: 2, y2025: 2 },
  486: { y2024: 1, y2025: 1 },
  490: { y2024: 2, y2025: 2 },
  492: { y2024: 13, y2025: 13 },
  496: { y2024: 2, y2025: 2 },
  499: { y2024: 0, y2025: 0 },
  500: { y2024: 3, y2025: 3 },
  501: { y2024: 9, y2025: 9 },
  504: { y2024: 1, y2025: 1 },
  505: { y2024: 6, y2025: 5 },
  507: { y2024: 4, y2025: 4 },
  510: { y2024: 2, y2025: 2 },
  512: { y2024: 5, y2025: 5 },
  513: { y2024: 12, y2025: 8 },
  515: { y2024: 13, y2025: 6 },
  516: { y2024: 12, y2025: 9 },
  520: { y2024: 8, y2025: 9 },
  524: { y2024: 13, y2025: 13 },
  527: { y2024: 1, y2025: 1 },
  528: { y2024: 7, y2025: 5 },
  529: { y2024: 5, y2025: 5 },
  532: { y2024: 7, y2025: 7 },
  534: { y2024: 3, y2025: 3 },
  535: { y2024: 3, y2025: 3 },
  537: { y2024: 4, y2025: 4 },
  538: { y2024: 5, y2025: 6 },
  546: { y2024: 0, y2025: 0 },
  548: { y2024: 5, y2025: 5 },
  549: { y2024: 13, y2025: 13 },
  551: { y2024: 5, y2025: 5 },
  552: { y2024: 2, y2025: 2 },
  554: { y2024: 5, y2025: 5 },
  558: { y2024: 8, y2025: 9 },
  560: { y2024: 4, y2025: 4 },
  561: { y2024: 12, y2025: 8 },
  562: { y2024: 13, y2025: 13 },
  563: { y2024: 0, y2025: 0 },
  565: { y2024: 6, y2025: 6 },
  566: { y2024: 4, y2025: 4 },
  567: { y2024: 8, y2025: 9 },
  569: { y2024: 4, y2025: 4 },
  570: { y2024: 8, y2025: 9 },
  575: { y2024: 8, y2025: 9 },
  576: { y2024: 6, y2025: 6 },
  577: { y2024: 3, y2025: 3 },
  579: { y2024: 5, y2025: 5 },
  581: { y2024: 2, y2025: 2 },
  582: { y2024: 1, y2025: 1 },
  583: { y2024: 0, y2025: 0 },
  587: { y2024: 8, y2025: 9 },
  588: { y2024: 2, y2025: 2 },
  592: { y2024: 13, y2025: 10 },
  597: { y2024: 3, y2025: 3 },
  601: { y2024: 13, y2025: 13 },
  609: { y2024: 1, y2025: 1 },
  610: { y2024: 6, y2025: 6 },
  614: { y2024: 2, y2025: 2 },
  615: { y2024: 1, y2025: 1 },
  617: { y2024: 1, y2025: 1 },
  619: { y2024: 13, y2025: 13 },
  621: { y2024: 2, y2025: 2 },
  623: { y2024: 9, y2025: 9 },
  627: { y2024: 13, y2025: 9 },
  632: { y2024: 0, y2025: 0 },
  634: { y2024: 1, y2025: 1 },
  635: { y2024: 2, y2025: 2 },
  638: { y2024: 2, y2025: 2 },
  639: { y2024: 4, y2025: 3 },
  641: { y2024: 3, y2025: 3 },
  643: { y2024: 1, y2025: 1 },
  645: { y2024: 8, y2025: 8 },
  646: { y2024: 13, y2025: 13 },
  647: { y2024: 3, y2025: 2 },
  648: { y2024: 9, y2025: 6 },
  653: { y2024: 9, y2025: 7 },
  654: { y2024: 3, y2025: 5 },
  655: { y2024: 4, y2025: 4 },
  657: { y2024: 5, y2025: 5 },
  661: { y2024: 8, y2025: 9 },
  662: { y2024: 2, y2025: 2 },
  664: { y2024: 0, y2025: 0 },
  667: { y2024: 10, y2025: 8 },
  668: { y2024: 4, y2025: 4 },
  670: { y2024: 8, y2025: 5 },
  673: { y2024: 8, y2025: 5 },
  674: { y2024: 1, y2025: 1 },
  675: { y2024: 2, y2025: 2 },
  677: { y2024: 1, y2025: 1 },
  678: { y2024: 13, y2025: 13 },
  679: { y2024: 3, y2025: 3 },
  680: { y2024: 1, y2025: 1 },
  681: { y2024: 3, y2025: 3 },
  683: { y2024: 8, y2025: 6 },
  685: { y2024: 7, y2025: 7 },
  686: { y2024: 5, y2025: 4 },
  687: { y2024: 4, y2025: 4 },
  689: { y2024: 3, y2025: 3 },
  691: { y2024: 11, y2025: 11 },
  692: { y2024: 2, y2025: 2 },
  693: { y2024: 3, y2025: 3 },
  694: { y2024: 3, y2025: 4 },
  697: { y2024: 3, y2025: 3 },
  698: { y2024: 9, y2025: 10 },
  699: { y2024: 0, y2025: 0 },
  702: { y2024: 5, y2025: 5 },
  704: { y2024: 6, y2025: 6 },
  705: { y2024: 13, y2025: 13 },
  706: { y2024: 2, y2025: 2 },
  707: { y2024: 5, y2025: 5 },
  710: { y2024: 4, y2025: 4 },
  711: { y2024: 13, y2025: 13 },
  712: { y2024: 8, y2025: 9 },
  713: { y2024: 1, y2025: 1 },
  716: { y2024: 1, y2025: 1 },
  717: { y2024: 1, y2025: 1 },
  718: { y2024: 1, y2025: 1 },
  719: { y2024: 8, y2025: 9 },
  720: { y2024: 1, y2025: 1 },
  723: { y2024: 4, y2025: 4 },
  726: { y2024: 13, y2025: 13 },
  728: { y2024: 2, y2025: 3 },
  729: { y2024: 1, y2025: 1 },
  730: { y2024: 3, y2025: 3 },
  731: { y2024: 1, y2025: 1 },
  733: { y2024: 13, y2025: 6 },
  734: { y2024: 7, y2025: 6 },
  735: { y2024: 0, y2025: 0 },
  737: { y2024: 1, y2025: 1 },
  738: { y2024: 8, y2025: 3 },
  739: { y2024: 1, y2025: 1 },
  741: { y2024: 6, y2025: 5 },
  743: { y2024: 5, y2025: 3 },
  744: { y2024: 12, y2025: 8 },
  745: { y2024: 1, y2025: 1 },
  747: { y2024: 8, y2025: 9 },
  751: { y2024: 3, y2025: 3 },
  752: { y2024: 3, y2025: 3 },
  754: { y2024: 13, y2025: 13 },
  755: { y2024: 2, y2025: 2 },
  758: { y2024: 1, y2025: 1 },
  759: { y2024: 3, y2025: 3 },
  760: { y2024: 5, y2025: 5 },
  763: { y2024: 4, y2025: 4 },
  765: { y2024: 2, y2025: 2 },
  766: { y2024: 4, y2025: 5 },
  767: { y2024: 3, y2025: 3 },
  768: { y2024: 5, y2025: 5 },
  769: { y2024: 5, y2025: 5 },
  771: { y2024: 5, y2025: 5 },
  772: { y2024: 2, y2025: 2 },
  773: { y2024: 4, y2025: 4 },
  774: { y2024: 9, y2025: 9 },
  777: { y2024: 13, y2025: 13 },
  779: { y2024: 4, y2025: 4 },
  780: { y2024: 4, y2025: 4 },
  781: { y2024: 2, y2025: 2 },
  782: { y2024: 5, y2025: 5 },
  783: { y2024: 5, y2025: 5 },
  784: { y2024: 2, y2025: 2 },
  785: { y2024: 5, y2025: 5 },
  786: { y2024: 9, y2025: 11 },
  787: { y2024: 3, y2025: 3 },
  790: { y2024: 4, y2025: 4 },
  794: { y2024: 5, y2025: 5 },
  796: { y2024: 1, y2025: 1 },
  797: { y2024: 5, y2025: 5 },
  799: { y2024: 7, y2025: 8 },
  801: { y2024: 3, y2025: 3 },
  804: { y2024: 13, y2025: 13 },
  805: { y2024: 5, y2025: 5 },
  810: { y2024: 9, y2025: 7 },
  811: { y2024: 3, y2025: 3 },
  813: { y2024: 5, y2025: 5 },
  814: { y2024: 9, y2025: 9 },
  818: { y2024: 2, y2025: 2 },
  820: { y2024: 5, y2025: 6 },
  822: { y2024: 4, y2025: 5 },
  823: { y2024: 2, y2025: 2 },
  824: { y2024: 2, y2025: 2 },
  826: { y2024: 13, y2025: 9 },
  827: { y2024: 8, y2025: 9 },
  829: { y2024: 8, y2025: 9 },
  830: { y2024: 3, y2025: 3 },
  831: { y2024: 3, y2025: 3 },
  833: { y2024: 9, y2025: 9 },
  834: { y2024: 13, y2025: 9 },
  835: { y2024: 8, y2025: 9 },
  836: { y2024: 8, y2025: 9 },
  837: { y2024: 7, y2025: 7 },
  838: { y2024: 13, y2025: 6 },
  840: { y2024: 8, y2025: 9 },
  841: { y2024: 4, y2025: 4 },
  843: { y2024: 13, y2025: 13 },
  844: { y2024: 4, y2025: 5 },
  846: { y2024: 13, y2025: 9 },
  847: { y2024: 7, y2025: 9 },
  849: { y2024: 3, y2025: 3 },
  853: { y2024: 5, y2025: 5 },
  855: { y2024: 0, y2025: 0 },
  860: { y2024: 2, y2025: 2 },
  861: { y2024: 9, y2025: 9 },
  862: { y2024: 2, y2025: 2 },
  863: { y2024: 6, y2025: 5 },
  864: { y2024: 2, y2025: 2 },
  865: { y2024: 6, y2025: 6 },
  866: { y2024: 13, y2025: 13 },
  867: { y2024: 6, y2025: 6 },
  869: { y2024: 12, y2025: 8 },
  870: { y2024: 1, y2025: 1 },
  872: { y2024: 5, y2025: 5 },
  873: { y2024: 1, y2025: 1 },
  874: { y2024: 2, y2025: 2 },
  875: { y2024: 1, y2025: 1 },
  876: { y2024: 4, y2025: 4 },
  877: { y2024: 2, y2025: 2 },
  878: { y2024: 3, y2025: 3 },
  879: { y2024: 8, y2025: 6 },
  881: { y2024: 4, y2025: 4 },
  887: { y2024: 1, y2025: 1 },
  889: { y2024: 2, y2025: 2 },
  891: { y2024: 3, y2025: 3 },
  892: { y2024: 1, y2025: 1 },
  893: { y2024: 2, y2025: 2 },
  894: { y2024: 2, y2025: 2 },
  897: { y2024: 2, y2025: 2 },
  900: { y2024: 2, y2025: 2 },
  901: { y2024: 13, y2025: 5 },
  902: { y2024: 4, y2025: 4 },
  903: { y2024: 3, y2025: 3 },
  904: { y2024: 0, y2025: 0 },
  905: { y2024: 1, y2025: 1 },
  906: { y2024: 3, y2025: 5 },
  907: { y2024: 9, y2025: 9 },
  908: { y2024: 12, y2025: 8 },
  909: { y2024: 3, y2025: 3 },
  910: { y2024: 8, y2025: 9 },
  912: { y2024: 13, y2025: 6 },
  913: { y2024: 8, y2025: 6 },
  917: { y2024: 13, y2025: 13 },
  918: { y2024: 13, y2025: 13 },
  919: { y2024: 8, y2025: 8 },
  921: { y2024: 7, y2025: 7 },
  922: { y2024: 3, y2025: 2 },
  926: { y2024: 4, y2025: 3 },
  927: { y2024: 4, y2025: 4 },
  928: { y2024: 13, y2025: 13 },
  929: { y2024: 9, y2025: 9 },
  932: { y2024: 4, y2025: 4 },
  938: { y2024: 3, y2025: 2 },
  939: { y2024: 6, y2025: 7 },
  942: { y2024: 4, y2025: 4 },
  943: { y2024: 13, y2025: 13 },
  944: { y2024: 13, y2025: 13 },
  948: { y2024: 2, y2025: 2 },
  951: { y2024: 2, y2025: 2 },
  952: { y2024: 2, y2025: 2 },
  953: { y2024: 2, y2025: 2 },
  955: { y2024: 6, y2025: 6 },
  956: { y2024: 5, y2025: 5 },
  957: { y2024: 4, y2025: 4 },
  958: { y2024: 1, y2025: 1 },
  960: { y2024: 2, y2025: 2 },
  961: { y2024: 6, y2025: 6 },
  963: { y2024: 8, y2025: 9 },
  966: { y2024: 13, y2025: 9 },
  967: { y2024: 4, y2025: 4 },
  968: { y2024: 2, y2025: 2 },
  969: { y2024: 6, y2025: 6 },
  970: { y2024: 4, y2025: 5 },
  971: { y2024: 10, y2025: 5 },
  974: { y2024: 6, y2025: 7 },
  975: { y2024: 2, y2025: 2 },
  976: { y2024: 13, y2025: 13 },
  979: { y2024: 13, y2025: 13 },
  980: { y2024: 10, y2025: 6 },
  981: { y2024: 1, y2025: 1 },
  982: { y2024: 3, y2025: 3 },
  983: { y2024: 2, y2025: 2 },
  984: { y2024: 13, y2025: 13 },
  985: { y2024: 1, y2025: 1 },
  990: { y2024: 9, y2025: 9 },
  991: { y2024: 3, y2025: 2 },
  992: { y2024: 5, y2025: 7 },
  993: { y2024: 0, y2025: 0 },
  994: { y2024: 2, y2025: 2 },
  996: { y2024: 3, y2025: 5 },
  997: { y2024: 9, y2025: 6 },
  998: { y2024: 5, y2025: 7 },
  999: { y2024: 5, y2025: 7 },
  1000: { y2024: 6, y2025: 6 },
  1001: { y2024: 6, y2025: 6 },
  1002: { y2024: 6, y2025: 6 },
  1003: { y2024: 4, y2025: 4 },
  1007: { y2024: 6, y2025: 6 },
  1008: { y2024: 13, y2025: 6 },
  1009: { y2024: 6, y2025: 6 },
  1010: { y2024: 2, y2025: 2 },
  1011: { y2024: 1, y2025: 1 },
  1012: { y2024: 8, y2025: 5 },
  1013: { y2024: 2, y2025: 2 },
  1014: { y2024: 5, y2025: 7 },
  1017: { y2024: 9, y2025: 7 },
  1018: { y2024: 13, y2025: 9 },
  1020: { y2024: 3, y2025: 2 },
  1021: { y2024: 2, y2025: 2 },
  1023: { y2024: 2, y2025: 2 },
  1024: { y2024: 13, y2025: 13 },
  1025: { y2024: 2, y2025: 2 },
  1026: { y2024: 1, y2025: 1 },
  1028: { y2024: 1, y2025: 1 },
  1029: { y2024: 13, y2025: 13 },
  1031: { y2024: 3, y2025: 3 },
  1036: { y2024: 9, y2025: 7 },
  1038: { y2024: 2, y2025: 2 },
  1039: { y2024: 6, y2025: 6 },
  1041: { y2024: 2, y2025: 3 },
  1042: { y2024: 6, y2025: 6 },
  1043: { y2024: 8, y2025: 8 },
  1045: { y2024: 4, y2025: 4 },
  1046: { y2024: 8, y2025: 6 },
  1047: { y2024: 0, y2025: 0 },
  1048: { y2024: 0, y2025: 0 },
  1051: { y2024: 8, y2025: 5 },
  1052: { y2024: 2, y2025: 2 },
  1053: { y2024: 5, y2025: 5 },
  1054: { y2024: 5, y2025: 5 },
  1057: { y2024: 1, y2025: 1 },
  1058: { y2024: 6, y2025: 6 },
  1059: { y2024: 7, y2025: 6 },
  1062: { y2024: 3, y2025: 3 },
  1064: { y2024: 2, y2025: 2 },
  1066: { y2024: 1, y2025: 1 },
  1068: { y2024: 8, y2025: 9 },
  1069: { y2024: 2, y2025: 2 },
  1070: { y2024: 2, y2025: 2 },
  1071: { y2024: 6, y2025: 5 },
  1072: { y2024: 2, y2025: 2 },
  1073: { y2024: 4, y2025: 4 },
  1074: { y2024: 13, y2025: 13 },
  1075: { y2024: 5, y2025: 5 },
  1076: { y2024: 6, y2025: 6 },
  1077: { y2024: 9, y2025: 11 },
  1079: { y2024: 3, y2025: 3 },
  1080: { y2024: 13, y2025: 13 },
  1081: { y2024: 12, y2025: 8 },
  1082: { y2024: 13, y2025: 8 },
  1084: { y2024: 13, y2025: 13 },
  1086: { y2024: 6, y2025: 6 },
  1087: { y2024: 2, y2025: 2 },
  1088: { y2024: 2, y2025: 2 },
  1089: { y2024: 2, y2025: 2 },
  1090: { y2024: 1, y2025: 1 },
  1091: { y2024: 13, y2025: 13 },
  1092: { y2024: 6, y2025: 5 },
  1094: { y2024: 4, y2025: 4 },
  1096: { y2024: 3, y2025: 3 },
  1097: { y2024: 2, y2025: 2 },
  1098: { y2024: 2, y2025: 2 },
  1100: { y2024: 5, y2025: 5 },
  1101: { y2024: 1, y2025: 1 },
  1102: { y2024: 2, y2025: 2 },
  1105: { y2024: 2, y2025: 2 },
  1107: { y2024: 2, y2025: 2 },
  1109: { y2024: 13, y2025: 13 },
  1110: { y2024: 8, y2025: 8 },
  1112: { y2024: 13, y2025: 13 },
  1113: { y2024: 3, y2025: 3 },
  1114: { y2024: 3, y2025: 3 },
  1115: { y2024: 4, y2025: 4 },
  1117: { y2024: 1, y2025: 1 },
  1118: { y2024: 5, y2025: 5 },
  1120: { y2024: 3, y2025: 3 },
  1121: { y2024: 2, y2025: 2 },
  1122: { y2024: 13, y2025: 5 },
  1123: { y2024: 13, y2025: 13 },
  1124: { y2024: 5, y2025: 5 },
  1125: { y2024: 10, y2025: 10 },
  1126: { y2024: 10, y2025: 10 },
  1128: { y2024: 3, y2025: 3 },
  1132: { y2024: 9, y2025: 9 },
  1133: { y2024: 4, y2025: 4 },
  1136: { y2024: 4, y2025: 4 },
  1138: { y2024: 2, y2025: 2 },
  1139: { y2024: 4, y2025: 4 },
  1141: { y2024: 7, y2025: 9 },
  1142: { y2024: 2, y2025: 2 },
  1143: { y2024: 4, y2025: 4 },
  1144: { y2024: 3, y2025: 3 },
  1145: { y2024: 13, y2025: 5 },
  1146: { y2024: 6, y2025: 5 },
  1147: { y2024: 3, y2025: 3 },
  1149: { y2024: 3, y2025: 3 },
  1150: { y2024: 2, y2025: 2 },
  1151: { y2024: 2, y2025: 2 },
  1152: { y2024: 2, y2025: 2 },
  1153: { y2024: 6, y2025: 6 },
  1154: { y2024: 4, y2025: 4 },
  1155: { y2024: 2, y2025: 2 },
  1156: { y2024: 5, y2025: 6 },
  1157: { y2024: 2, y2025: 2 },
  1158: { y2024: 4, y2025: 3 },
  1159: { y2024: 13, y2025: 13 },
  1160: { y2024: 10, y2025: 9 },
  1161: { y2024: 2, y2025: 2 },
  1162: { y2024: 3, y2025: 3 },
  1163: { y2024: 8, y2025: 6 },
  1164: { y2024: 9, y2025: 7 },
  1165: { y2024: 13, y2025: 6 },
  1166: { y2024: 13, y2025: 13 },
  1169: { y2024: 1, y2025: 1 },
  1170: { y2024: 1, y2025: 1 },
  1173: { y2024: 4, y2025: 6 },
  1174: { y2024: 2, y2025: 2 },
  1175: { y2024: 5, y2025: 7 },
  1177: { y2024: 6, y2025: 7 },
  1179: { y2024: 5, y2025: 5 },
  1180: { y2024: 9, y2025: 10 },
  1181: { y2024: 6, y2025: 6 },
  1182: { y2024: 2, y2025: 2 },
  1184: { y2024: 2, y2025: 2 },
  1186: { y2024: 3, y2025: 3 },
  1187: { y2024: 13, y2025: 13 },
  1188: { y2024: 13, y2025: 13 },
  1189: { y2024: 9, y2025: 9 },
  1192: { y2024: 1, y2025: 1 },
  1193: { y2024: 2, y2025: 2 },
  1194: { y2024: 3, y2025: 2 },
  1207: { y2024: 5, y2025: 5 },
  1208: { y2024: 2, y2025: 2 },
  1209: { y2024: 5, y2025: 6 },
  1210: { y2024: 2, y2025: 2 },
  1212: { y2024: 5, y2025: 5 },
  1213: { y2024: 5, y2025: 5 },
  1214: { y2024: 2, y2025: 2 },
  1217: { y2024: 13, y2025: 10 },
  1219: { y2024: 2, y2025: 2 },
  1220: { y2024: 3, y2025: 2 },
  1222: { y2024: 1, y2025: 1 },
  1225: { y2024: 4, y2025: 4 },
  1226: { y2024: 1, y2025: 1 },
  1227: { y2024: 5, y2025: 5 },
  1229: { y2024: 1, y2025: 1 },
  1230: { y2024: 3, y2025: 3 },
  1233: { y2024: 0, y2025: 0 },
  1235: { y2024: 6, y2025: 7 },
  1236: { y2024: 9, y2025: 9 },
  1237: { y2024: 2, y2025: 2 },
  1238: { y2024: 2, y2025: 2 },
  1242: { y2024: 0, y2025: 0 },
  1244: { y2024: 5, y2025: 6 },
  1246: { y2024: 2, y2025: 2 },
  1247: { y2024: 4, y2025: 4 },
  1248: { y2024: 1, y2025: 1 },
  1251: { y2024: 2, y2025: 2 },
  1252: { y2024: 6, y2025: 6 },
  1253: { y2024: 2, y2025: 2 },
  1257: { y2024: 13, y2025: 13 },
  1258: { y2024: 1, y2025: 1 },
  1260: { y2024: 5, y2025: 6 },
  1261: { y2024: 8, y2025: 9 },
  1262: { y2024: 2, y2025: 2 },
  1263: { y2024: 11, y2025: 11 },
  1265: { y2024: 8, y2025: 5 },
  1266: { y2024: 0, y2025: 0 },
  1267: { y2024: 1, y2025: 1 },
  1268: { y2024: 2, y2025: 2 },
  1269: { y2024: 2, y2025: 2 },
  1272: { y2024: 3, y2025: 4 },
  1273: { y2024: 9, y2025: 9 },
  1274: { y2024: 13, y2025: 13 },
  1276: { y2024: 8, y2025: 9 },
  1277: { y2024: 2, y2025: 2 },
  1279: { y2024: 8, y2025: 8 },
  1280: { y2024: 1, y2025: 1 },
  1282: { y2024: 2, y2025: 2 },
  1283: { y2024: 2, y2025: 2 },
  1285: { y2024: 7, y2025: 6 },
  1286: { y2024: 3, y2025: 3 },
  1287: { y2024: 1, y2025: 1 },
  1288: { y2024: 8, y2025: 5 },
  1289: { y2024: 2, y2025: 2 },
  1290: { y2024: 2, y2025: 2 },
  1291: { y2024: 13, y2025: 13 },
  1294: { y2024: 7, y2025: 6 },
  1298: { y2024: 0, y2025: 0 },
  1299: { y2024: 8, y2025: 8 },
  1300: { y2024: 8, y2025: 8 },
  1301: { y2024: 8, y2025: 8 },
  1302: { y2024: 6, y2025: 5 },
  1304: { y2024: 5, y2025: 7 },
  1306: { y2024: 1, y2025: 1 },
  1307: { y2024: 9, y2025: 11 },
  1308: { y2024: 1, y2025: 1 },
  1309: { y2024: 0, y2025: 0 },
  1310: { y2024: 2, y2025: 2 },
  1311: { y2024: 2, y2025: 2 },
  1312: { y2024: 3, y2025: 3 },
  1315: { y2024: 5, y2025: 5 },
  1316: { y2024: 5, y2025: 5 },
  1317: { y2024: 2, y2025: 3 },
  1318: { y2024: 3, y2025: 3 },
  1320: { y2024: 5, y2025: 5 },
  1321: { y2024: 5, y2025: 5 },
  1323: { y2024: 3, y2025: 3 },
  1325: { y2024: 6, y2025: 6 },
  1327: { y2024: 0, y2025: 0 },
  1328: { y2024: 3, y2025: 4 },
  1330: { y2024: 1, y2025: 1 },
  1331: { y2024: 13, y2025: 13 },
  1333: { y2024: 8, y2025: 10 },
  1334: { y2024: 8, y2025: 9 },
  1336: { y2024: 3, y2025: 3 },
  1338: { y2024: 9, y2025: 9 },
  1339: { y2024: 3, y2025: 3 },
  1340: { y2024: 3, y2025: 3 },
  1342: { y2024: 6, y2025: 6 },
  1343: { y2024: 5, y2025: 7 },
  1344: { y2024: 7, y2025: 9 },
  1345: { y2024: 13, y2025: 6 },
  1346: { y2024: 8, y2025: 9 },
  1347: { y2024: 7, y2025: 5 },
  1349: { y2024: 13, y2025: 13 },
  1350: { y2024: 5, y2025: 5 },
  1351: { y2024: 5, y2025: 5 },
  1352: { y2024: 13, y2025: 6 },
  1353: { y2024: 13, y2025: 6 },
  1354: { y2024: 5, y2025: 6 },
  1355: { y2024: 5, y2025: 6 },
  1357: { y2024: 6, y2025: 6 },
  1358: { y2024: 6, y2025: 6 },
  1361: { y2024: 2, y2025: 2 },
  1362: { y2024: 13, y2025: 6 },
  1363: { y2024: 3, y2025: 4 },
  1365: { y2024: 2, y2025: 3 },
  1366: { y2024: 3, y2025: 5 },
  1367: { y2024: 0, y2025: 0 },
  1368: { y2024: 5, y2025: 5 },
  1369: { y2024: 5, y2025: 5 },
  1375: { y2024: 0, y2025: 0 },
  1376: { y2024: 0, y2025: 0 },
  1377: { y2024: 3, y2025: 3 },
  1378: { y2024: 2, y2025: 2 },
  1379: { y2024: 11, y2025: 10 },
  1380: { y2024: 13, y2025: 13 },
  1381: { y2024: 2, y2025: 2 },
  1382: { y2024: 5, y2025: 5 },
  1384: { y2024: 11, y2025: 10 },
  1385: { y2024: 10, y2025: 10 },
  1386: { y2024: 11, y2025: 10 },
  1388: { y2024: 11, y2025: 10 },
  1389: { y2024: 11, y2025: 10 },
  1391: { y2024: 11, y2025: 10 },
  1392: { y2024: 10, y2025: 10 },
  1393: { y2024: 0, y2025: 0 },
  1394: { y2024: 4, y2025: 5 },
  1395: { y2024: 10, y2025: 10 },
  1396: { y2024: 13, y2025: 9 },
  1397: { y2024: 5, y2025: 5 },
  1398: { y2024: 8, y2025: 6 },
  1399: { y2024: 4, y2025: 5 },
  1400: { y2024: 12, y2025: 9 },
  1401: { y2024: 3, y2025: 3 },
  1402: { y2024: 7, y2025: 9 },
  1404: { y2024: 3, y2025: 3 },
  1405: { y2024: 13, y2025: 9 },
  1406: { y2024: 5, y2025: 5 },
  1408: { y2024: 7, y2025: 9 },
  1409: { y2024: 2, y2025: 2 },
  1410: { y2024: 1, y2025: 1 },
  1412: { y2024: 1, y2025: 1 },
  1413: { y2024: 6, y2025: 6 },
  1414: { y2024: 2, y2025: 2 },
  1416: { y2024: 5, y2025: 5 },
  1417: { y2024: 2, y2025: 2 },
  1418: { y2024: 3, y2025: 2 },
  1419: { y2024: 13, y2025: 13 },
  1420: { y2024: 2, y2025: 2 },
  1422: { y2024: 4, y2025: 5 },
  1423: { y2024: 7, y2025: 9 },
  1425: { y2024: 5, y2025: 5 },
  1426: { y2024: 5, y2025: 5 },
  1427: { y2024: 12, y2025: 11 },
  1429: { y2024: 10, y2025: 10 },
  1430: { y2024: 11, y2025: 10 },
  1431: { y2024: 2, y2025: 2 },
  1432: { y2024: 3, y2025: 2 },
  1433: { y2024: 2, y2025: 2 },
  1435: { y2024: 3, y2025: 3 },
  1436: { y2024: 11, y2025: 10 },
  1439: { y2024: 6, y2025: 6 },
  1441: { y2024: 12, y2025: 9 },
  1442: { y2024: 5, y2025: 5 },
  1443: { y2024: 4, y2025: 4 },
  1444: { y2024: 2, y2025: 2 },
  1445: { y2024: 2, y2025: 2 },
  1447: { y2024: 1, y2025: 2 },
  1448: { y2024: 13, y2025: 5 },
  1450: { y2024: 5, y2025: 5 },
  1451: { y2024: 2, y2025: 2 },
  1452: { y2024: 2, y2025: 2 },
  1454: { y2024: 6, y2025: 11 },
  1456: { y2024: 13, y2025: 3 },
  1457: { y2024: 10, y2025: 10 },
  1458: { y2024: 3, y2025: 2 },
  1459: { y2024: 5, y2025: 5 },
  1460: { y2024: 10, y2025: 10 },
  1461: { y2024: 1, y2025: 1 },
  1462: { y2024: 13, y2025: 9 },
  1463: { y2024: 2, y2025: 2 },
  1464: { y2024: 3, y2025: 3 },
  1466: { y2024: 2, y2025: 2 },
  1467: { y2024: 3, y2025: 2 },
  1471: { y2024: 3, y2025: 3 },
  1474: { y2024: 8, y2025: 8 },
  1476: { y2024: 5, y2025: 5 },
  1477: { y2024: 10, y2025: 8 },
  1480: { y2024: 13, y2025: 13 },
  1481: { y2024: 13, y2025: 9 },
  1482: { y2024: 13, y2025: 9 },
  1483: { y2024: 3, y2025: 4 },
  1484: { y2024: 4, y2025: 4 },
  1486: { y2024: 6, y2025: 7 },
  1487: { y2024: 2, y2025: 2 },
  1488: { y2024: 1, y2025: 1 },
  1489: { y2024: 3, y2025: 3 },
  1490: { y2024: 9, y2025: 8 },
  1491: { y2024: 3, y2025: 4 },
  1492: { y2024: 5, y2025: 5 },
  1493: { y2024: 5, y2025: 6 },
  1494: { y2024: 2, y2025: 2 },
  1497: { y2024: 3, y2025: 3 },
  1499: { y2024: 12, y2025: 9 },
  1503: { y2024: 3, y2025: 3 },
  1504: { y2024: 5, y2025: 5 },
  1505: { y2024: 12, y2025: 9 },
  1506: { y2024: 4, y2025: 5 },
  1507: { y2024: 4, y2025: 5 },
  1508: { y2024: 13, y2025: 13 },
  1509: { y2024: 2, y2025: 2 },
  1510: { y2024: 13, y2025: 9 },
  1511: { y2024: 2, y2025: 2 },
  1513: { y2024: 1, y2025: 2 },
  1514: { y2024: 13, y2025: 9 },
  1516: { y2024: 12, y2025: 11 },
  1517: { y2024: 13, y2025: 13 },
  1518: { y2024: 13, y2025: 9 },
  1519: { y2024: 8, y2025: 9 },
  1520: { y2024: 13, y2025: 10 },
  1521: { y2024: 7, y2025: 5 },
  1523: { y2024: 5, y2025: 5 },
  1525: { y2024: 2, y2025: 2 },
  1526: { y2024: 7, y2025: 5 },
  1527: { y2024: 1, y2025: 1 },
  1528: { y2024: 9, y2025: 9 },
  1529: { y2024: 7, y2025: 5 },
  1530: { y2024: 7, y2025: 5 },
  1531: { y2024: 5, y2025: 5 },
  1532: { y2024: 1, y2025: 1 },
  1533: { y2024: 13, y2025: 13 },
  1534: { y2024: 6, y2025: 5 },
  1536: { y2024: 5, y2025: 3 },
  1537: { y2024: 2, y2025: 2 },
  1538: { y2024: 7, y2025: 6 },
  1539: { y2024: 12, y2025: 9 },
  1540: { y2024: 5, y2025: 7 },
  1541: { y2024: 1, y2025: 1 },
  1542: { y2024: 2, y2025: 2 },
  1543: { y2024: 5, y2025: 5 },
  1545: { y2024: 2, y2025: 2 },
  1546: { y2024: 3, y2025: 3 },
  1547: { y2024: 3, y2025: 3 },
  1548: { y2024: 1, y2025: 1 },
  1549: { y2024: 9, y2025: 9 },
  1552: { y2024: 11, y2025: 9 },
  1553: { y2024: 13, y2025: 13 },
  1554: { y2024: 11, y2025: 10 },
  1555: { y2024: 10, y2025: 10 },
  1556: { y2024: 13, y2025: 13 },
  1557: { y2024: 10, y2025: 10 },
  1558: { y2024: 2, y2025: 2 },
  1559: { y2024: 9, y2025: 9 },
  1560: { y2024: 2, y2025: 2 },
  1561: { y2024: 3, y2025: 2 },
  1562: { y2024: 11, y2025: 10 },
  1564: { y2024: 0, y2025: 0 },
  1566: { y2024: 2, y2025: 2 },
  1567: { y2024: 3, y2025: 2 },
  1568: { y2024: 2, y2025: 2 },
  1569: { y2024: 5, y2025: 6 },
  1570: { y2024: 5, y2025: 4 },
  1571: { y2024: 2, y2025: 2 },
  1572: { y2024: 5, y2025: 5 },
  1573: { y2024: 10, y2025: 10 },
  1574: { y2024: 6, y2025: 5 },
  1575: { y2024: 2, y2025: 2 },
  1577: { y2024: 1, y2025: 1 },
  1578: { y2024: 1, y2025: 1 },
  1579: { y2024: 10, y2025: 8 },
  1580: { y2024: 5, y2025: 5 },
  1581: { y2024: 4, y2025: 6 },
  1583: { y2024: 3, y2025: 2 },
  1584: { y2024: 5, y2025: 6 },
  1585: { y2024: 4, y2025: 5 },
  1586: { y2024: 6, y2025: 5 },
  1587: { y2024: 13, y2025: 13 },
  1588: { y2024: 3, y2025: 5 },
  1589: { y2024: 3, y2025: 4 },
  1590: { y2024: 2, y2025: 2 },
  1593: { y2024: 6, y2025: 6 },
  1594: { y2024: 2, y2025: 3 },
  1596: { y2024: 4, y2025: 4 },
  1600: { y2024: 2, y2025: 2 },
  1601: { y2024: 3, y2025: 3 },
  1603: { y2024: 2, y2025: 2 },
  1604: { y2024: 13, y2025: 13 },
  1605: { y2024: 5, y2025: 5 },
  1606: { y2024: 2, y2025: 2 },
  1607: { y2024: 13, y2025: 9 },
  1608: { y2024: 5, y2025: 5 },
  1609: { y2024: 10, y2025: 10 },
  1610: { y2024: 10, y2025: 10 },
  1611: { y2024: 10, y2025: 10 },
  1612: { y2024: 11, y2025: 10 },
  1613: { y2024: 2, y2025: 2 },
  1614: { y2024: 4, y2025: 4 },
  1616: { y2024: 8, y2025: 7 },
  1617: { y2024: 5, y2025: 5 },
  1621: { y2024: 5, y2025: 4 },
  1622: { y2024: 2, y2025: 2 },
  1625: { y2024: 6, y2025: 6 },
  1626: { y2024: 9, y2025: 9 },
  1627: { y2024: 13, y2025: 13 },
  1628: { y2024: 4, y2025: 4 },
  1629: { y2024: 8, y2025: 5 },
  1630: { y2024: 5, y2025: 5 },
  1631: { y2024: 9, y2025: 9 },
  1632: { y2024: 10, y2025: 10 },
  1633: { y2024: 3, y2025: 5 },
  1634: { y2024: 5, y2025: 5 },
  1635: { y2024: 4, y2025: 4 },
  1636: { y2024: 4, y2025: 4 },
  1637: { y2024: 2, y2025: 2 },
  1638: { y2024: 8, y2025: 9 },
  1639: { y2024: 5, y2025: 5 },
  1641: { y2024: 3, y2025: 4 },
  1642: { y2024: 9, y2025: 9 },
  1643: { y2024: 4, y2025: 4 },
  1644: { y2024: 4, y2025: 4 },
  1646: { y2024: 10, y2025: 10 },
  1647: { y2024: 13, y2025: 6 },
  1648: { y2024: 13, y2025: 9 },
  1649: { y2024: 2, y2025: 2 },
  1650: { y2024: 8, y2025: 5 },
  1652: { y2024: 5, y2025: 5 },
  1653: { y2024: 13, y2025: 9 },
  1655: { y2024: 5, y2025: 5 },
  1656: { y2024: 4, y2025: 5 },
  1657: { y2024: 12, y2025: 11 },
  1658: { y2024: 12, y2025: 9 },
  1659: { y2024: 2, y2025: 3 },
  1661: { y2024: 7, y2025: 7 },
  1662: { y2024: 13, y2025: 13 },
  1663: { y2024: 2, y2025: 2 },
  1664: { y2024: 2, y2025: 2 },
  1665: { y2024: 2, y2025: 2 },
  1666: { y2024: 3, y2025: 3 },
  1667: { y2024: 4, y2025: 4 },
  1668: { y2024: 2, y2025: 2 },
  1669: { y2024: 9, y2025: 9 },
  1670: { y2024: 11, y2025: 10 },
  1671: { y2024: 1, y2025: 1 },
  1672: { y2024: 13, y2025: 13 },
  1673: { y2024: 2, y2025: 2 },
  1674: { y2024: 2, y2025: 2 },
  1675: { y2024: 5, y2025: 5 },
  1676: { y2024: 1, y2025: 1 },
  1678: { y2024: 13, y2025: 13 },
  1679: { y2024: 3, y2025: 3 },
  1680: { y2024: 1, y2025: 1 },
  1681: { y2024: 3, y2025: 3 },
  1682: { y2024: 9, y2025: 9 },
  1683: { y2024: 0, y2025: 0 },
  1684: { y2024: 1, y2025: 1 },
  1685: { y2024: 1, y2025: 1 },
  1686: { y2024: 4, y2025: 3 },
  1687: { y2024: 13, y2025: 13 },
  1688: { y2024: 9, y2025: 7 },
  1689: { y2024: 5, y2025: 7 },
  1691: { y2024: 0, y2025: 0 },
  1692: { y2024: 2, y2025: 2 },
  1696: { y2024: 1, y2025: 1 },
  1697: { y2024: 8, y2025: 9 },
  1698: { y2024: 3, y2025: 3 },
  1699: { y2024: 10, y2025: 10 },
  1700: { y2024: 1, y2025: 1 },
  1701: { y2024: 12, y2025: 11 },
  1703: { y2024: 6, y2025: 6 },
  1704: { y2024: 11, y2025: 7 },
  1705: { y2024: 4, y2025: 4 },
  1706: { y2024: 2, y2025: 3 },
  1708: { y2024: 3, y2025: 3 },
  1709: { y2024: 1, y2025: 1 },
  1710: { y2024: 1, y2025: 1 },
  1711: { y2024: 13, y2025: 10 },
  1712: { y2024: 2, y2025: 2 },
  1713: { y2024: 11, y2025: 7 },
  1714: { y2024: 3, y2025: 3 },
  1715: { y2024: 13, y2025: 13 },
  1716: { y2024: 13, y2025: 9 },
  1717: { y2024: 1, y2025: 1 },
  1718: { y2024: 4, y2025: 4 },
  1719: { y2024: 3, y2025: 3 },
  1720: { y2024: 2, y2025: 2 },
  1722: { y2024: 4, y2025: 5 },
  1723: { y2024: 4, y2025: 4 },
  1724: { y2024: 0, y2025: 0 },
  1725: { y2024: 13, y2025: 10 },
  1726: { y2024: 0, y2025: 0 },
  1727: { y2024: 3, y2025: 3 },
  1728: { y2024: 13, y2025: 10 },
  1730: { y2024: 5, y2025: 4 },
  1731: { y2024: 5, y2025: 5 },
  1732: { y2024: 2, y2025: 2 },
  1733: { y2024: 0, y2025: 0 },
  1735: { y2024: 11, y2025: 7 },
  1736: { y2024: 7, y2025: 6 },
  1737: { y2024: 9, y2025: 10 },
  1738: { y2024: 3, y2025: 3 },
  1740: { y2024: 6, y2025: 5 },
  1741: { y2024: 4, y2025: 4 },
  1743: { y2024: 5, y2025: 6 },
  1744: { y2024: 6, y2025: 6 },
  1746: { y2024: 13, y2025: 13 },
  1747: { y2024: 3, y2025: 3 },
  1748: { y2024: 2, y2025: 2 },
  1749: { y2024: 3, y2025: 3 },
  1750: { y2024: 13, y2025: 13 },
  1751: { y2024: 2, y2025: 2 },
  1752: { y2024: 2, y2025: 2 },
  1753: { y2024: 12, y2025: 9 },
  1756: { y2024: 4, y2025: 4 },
  1758: { y2024: 12, y2025: 6 },
  1759: { y2024: 13, y2025: 13 },
  1760: { y2024: 9, y2025: 6 },
  1761: { y2024: 12, y2025: 9 },
  1762: { y2024: 8, y2025: 5 },
  1763: { y2024: 3, y2025: 3 },
  1764: { y2024: 4, y2025: 5 },
  1766: { y2024: 4, y2025: 5 },
  1767: { y2024: 6, y2025: 6 },
  1768: { y2024: 0, y2025: 0 },
  1769: { y2024: 2, y2025: 2 },
  1770: { y2024: 0, y2025: 0 },
  1771: { y2024: 13, y2025: 13 },
  1772: { y2024: 13, y2025: 13 },
  1773: { y2024: 5, y2025: 5 },
  1774: { y2024: 2, y2025: 2 },
  1775: { y2024: 5, y2025: 5 },
  1776: { y2024: 2, y2025: 2 },
  1777: { y2024: 4, y2025: 5 },
  1778: { y2024: 9, y2025: 9 },
  1779: { y2024: 13, y2025: 6 },
  1781: { y2024: 2, y2025: 2 },
  1784: { y2024: 2, y2025: 2 },
  1785: { y2024: 13, y2025: 13 },
  1786: { y2024: 9, y2025: 9 },
  1787: { y2024: 1, y2025: 1 },
  1789: { y2024: 0, y2025: 0 },
  1790: { y2024: 2, y2025: 2 },
  1791: { y2024: 13, y2025: 9 },
  1792: { y2024: 9, y2025: 9 },
  1794: { y2024: 0, y2025: 0 },
  1795: { y2024: 2, y2025: 2 },
  1796: { y2024: 13, y2025: 13 },
  1797: { y2024: 6, y2025: 5 },
  1799: { y2024: 12, y2025: 9 },
  1802: { y2024: 4, y2025: 2 },
  1803: { y2024: 13, y2025: 13 },
  1804: { y2024: 1, y2025: 1 },
  1805: { y2024: 2, y2025: 2 },
  1806: { y2024: 5, y2025: 6 },
  1807: { y2024: 3, y2025: 3 },
  1808: { y2024: 5, y2025: 5 },
  1809: { y2024: 9, y2025: 8 },
  1812: { y2024: 4, y2025: 5 },
  1813: { y2024: 13, y2025: 9 },
  1815: { y2024: 5, y2025: 6 },
  1847: { y2024: 0, y2025: 0 },
  1874: { y2024: 4, y2025: 5 },
  1876: { y2024: 4, y2025: 4 },
  1912: { y2024: 11, y2025: 10 },
  1941: { y2024: 5, y2025: 5 },
  1944: { y2024: 13, y2025: 13 },
  1956: { y2024: 13, y2025: 13 },
  1958: { y2024: 7, y2025: 9 },
  1978: { y2024: 1, y2025: 1 },
  1990: { y2024: 9, y2025: 7 },
  1999: { y2024: 3, y2025: 4 },
  2009: { y2024: 7, y2025: 6 },
  2020: { y2024: 4, y2025: 4 },
  2021: { y2024: 2, y2025: 2 },
  2024: { y2024: 1, y2025: 1 },
  2026: { y2024: 2, y2025: 3 },
  2036: { y2024: 3, y2025: 3 },
  2061: { y2024: 5, y2025: 5 },
  2062: { y2024: 1, y2025: 1 },
  2071: { y2024: 9, y2025: 9 },
  2083: { y2024: 5, y2025: 4 },
  2084: { y2024: 5, y2025: 4 },
  2085: { y2024: 5, y2025: 4 },
  2102: { y2024: 12, y2025: 8 },
  2107: { y2024: 3, y2025: 4 },
  2112: { y2024: 2, y2025: 2 },
  2149: { y2024: 3, y2025: 3 },
  2150: { y2024: 6, y2025: 6 },
  2151: { y2024: 2, y2025: 2 },
  2192: { y2024: 6, y2025: 7 },
  2209: { y2024: 7, y2025: 9 },
  2211: { y2024: 3, y2025: 3 },
  2223: { y2024: 4, y2025: 4 },
  2273: { y2024: 1, y2025: 2 },
  2294: { y2024: 3, y2025: 2 },
  2295: { y2024: 1, y2025: 1 },
  2297: { y2024: 3, y2025: 3 },
  2313: { y2024: 4, y2025: 5 },
  2314: { y2024: 4, y2025: 5 },
  2315: { y2024: 4, y2025: 5 },
  2331: { y2024: 3, y2025: 3 },
  2336: { y2024: 13, y2025: 9 },
  2349: { y2024: 2, y2025: 3 },
  2350: { y2024: 13, y2025: 9 },
  2354: { y2024: 2, y2025: 2 },
  2405: { y2024: 11, y2025: 11 },
  2406: { y2024: 2, y2025: 2 },
  2411: { y2024: 0, y2025: 0 },
  2412: { y2024: 0, y2025: 0 },
  2415: { y2024: 5, y2025: 5 },
  2416: { y2024: 3, y2025: 3 },
  2428: { y2024: 2, y2025: 2 },
  2433: { y2024: 8, y2025: 8 },
  2436: { y2024: 6, y2025: 6 },
  2475: { y2024: 12, y2025: 9 },
  2478: { y2024: 4, y2025: 4 },
  2479: { y2024: 4, y2025: 4 },
  2482: { y2024: 4, y2025: 4 },
  2484: { y2024: 4, y2025: 5 },
  2496: { y2024: 5, y2025: 6 },
  2506: { y2024: 6, y2025: 6 },
  2511: { y2024: 5, y2025: 5 },
  2519: { y2024: 4, y2025: 4 },
  2521: { y2024: 7, y2025: 9 },
  2546: { y2024: 5, y2025: 5 },
  2547: { y2024: 12, y2025: 9 },
  2554: { y2024: 11, y2025: 10 },
  2587: { y2024: 5, y2025: 5 },
  2638: { y2024: 2, y2025: 2 },
  2644: { y2024: 1, y2025: 1 },
  2649: { y2024: 5, y2025: 5 },
  2667: { y2024: 2, y2025: 2 },
  2696: { y2024: 5, y2025: 6 },
  2698: { y2024: 2, y2025: 2 },
  2709: { y2024: 2, y2025: 2 },
  2768: { y2024: 1, y2025: 1 },
  2769: { y2024: 6, y2025: 5 },
  2787: { y2024: 10, y2025: 10 },
  2788: { y2024: 10, y2025: 10 },
  2799: { y2024: 10, y2025: 10 },
  2812: { y2024: 5, y2025: 9 },
  2834: { y2024: 8, y2025: 4 },
  2863: { y2024: 5, y2025: 3 },
  2904: { y2024: 8, y2025: 5 },
  2908: { y2024: 4, y2025: 1 },
  2917: { y2024: 8, y2025: 5 },
  2936: { y2024: 2, y2025: 2 },
  2939: { y2024: 9, y2025: 6 },
  2945: { y2024: 5, y2025: 5 },
  2955: { y2024: 4, y2025: 13 },
  2963: { y2024: 5, y2025: 5 },
  2965: { y2024: 5, y2025: 5 },
  3000: { y2024: 4, y2025: 3 },
  3011: { y2024: 0, y2025: 13 },
  3024: { y2024: 13, y2025: 2 },
  3144: { y2024: 13, y2025: 4 },
  3157: { y2024: 2, y2025: 2 },
  3165: { y2024: 4, y2025: 4 },
  3318: { y2024: 13, y2025: 9 },
  3321: { y2024: 3, y2025: 3 },
  3345: { y2024: 13, y2025: 13 },
  3440: { y2024: 3, y2025: 10 },
  3447: { y2024: 13, y2025: 3 },
  3449: { y2024: 11, y2025: 3 },
  3461: { y2024: 11, y2025: 9 },
  3482: { y2024: 1, y2025: 7 },
  3513: { y2024: 4, y2025: 5 },
  3515: { y2024: 4, y2025: 6 },
  3518: { y2024: 13, y2025: 2 },
  6799: { y2024: 2, y2025: 2 },
  11572: { y2024: 0, y2025: 0 },
  55555: { y2024: 0, y2025: 0 },
  976543: { y2024: 0, y2025: 0 },
    64: { y2024: 1, y2025: 1 },
  1816: { y2024: 1, y2025: 1 },
  1817: { y2024: 5, y2025: 5 },
  1818: { y2024: 0, y2025: 0 },
  1819: { y2024: 0, y2025: 0 },
  1820: { y2024: 13, y2025: 9 },
  1821: { y2024: 3, y2025: 3 },
  1822: { y2024: 13, y2025: 10 },
  1823: { y2024: 2, y2025: 2 },
  1824: { y2024: 13, y2025: 8 },
  1825: { y2024: 5, y2025: 5 },
  1826: { y2024: 6, y2025: 6 },
  1827: { y2024: 0, y2025: 0 },
  1829: { y2024: 1, y2025: 1 },
  1830: { y2024: 6, y2025: 10 },
  1831: { y2024: 9, y2025: 9 },
  1832: { y2024: 1, y2025: 2 },
  1833: { y2024: 2, y2025: 2 },
  1834: { y2024: 5, y2025: 6 },
  1835: { y2024: 0, y2025: 0 },
  1836: { y2024: 0, y2025: 4 },
  1837: { y2024: 13, y2025: 13 },
  1838: { y2024: 3, y2025: 2 },
  1839: { y2024: 3, y2025: 5 },
  1841: { y2024: 5, y2025: 6 },
  1842: { y2024: 1, y2025: 1 },
  1843: { y2024: 12, y2025: 9 },
  1844: { y2024: 13, y2025: 13 },
  1845: { y2024: 7, y2025: 9 },
  1846: { y2024: 3, y2025: 3 },
  1848: { y2024: 8, y2025: 8 },
  1849: { y2024: 0, y2025: 0 },
  1850: { y2024: 3, y2025: 3 },
  1851: { y2024: 9, y2025: 9 },
  1852: { y2024: 6, y2025: 10 },
  1854: { y2024: 10, y2025: 10 },
  1855: { y2024: 2, y2025: 2 },
  1856: { y2024: 3, y2025: 2 },
  1858: { y2024: 5, y2025: 6 },
  1859: { y2024: 1, y2025: 1 },
  1860: { y2024: 13, y2025: 13 },
  1861: { y2024: 1, y2025: 1 },
  1862: { y2024: 13, y2025: 13 },
  1865: { y2024: 5, y2025: 6 },
  1866: { y2024: 3, y2025: 2 },
  1867: { y2024: 2, y2025: 2 },
  1868: { y2024: 13, y2025: 13 },
  1869: { y2024: 11, y2025: 11 },
  1870: { y2024: 7, y2025: 6 },
  1871: { y2024: 13, y2025: 10 },
  1872: { y2024: 11, y2025: 10 },
  1873: { y2024: 5, y2025: 6 },
  1875: { y2024: 5, y2025: 6 },
  1878: { y2024: 1, y2025: 1 },
  1879: { y2024: 1, y2025: 1 },
  1881: { y2024: 2, y2025: 3 },
  1884: { y2024: 5, y2025: 5 },
  1885: { y2024: 5, y2025: 5 },
  1886: { y2024: 0, y2025: 0 },
  1887: { y2024: 0, y2025: 0 },
  1888: { y2024: 13, y2025: 13 },
  1889: { y2024: 9, y2025: 8 },
  1891: { y2024: 9, y2025: 10 },
  1892: { y2024: 3, y2025: 3 },
  1893: { y2024: 13, y2025: 13 },
  1894: { y2024: 13, y2025: 13 },
  1895: { y2024: 0, y2025: 0 },
  1896: { y2024: 1, y2025: 1 },
  1897: { y2024: 7, y2025: 8 },
  1898: { y2024: 2, y2025: 2 },
  1899: { y2024: 0, y2025: 0 },
  1900: { y2024: 1, y2025: 1 },
  1901: { y2024: 9, y2025: 9 },
  1902: { y2024: 13, y2025: 13 },
  1903: { y2024: 6, y2025: 7 },
  1904: { y2024: 0, y2025: 0 },
  1905: { y2024: 8, y2025: 10 },
  1906: { y2024: 1, y2025: 1 },
  1907: { y2024: 3, y2025: 2 },
  1909: { y2024: 6, y2025: 6 },
  1910: { y2024: 2, y2025: 2 },
  1911: { y2024: 8, y2025: 9 },
  1914: { y2024: 13, y2025: 13 },
  1915: { y2024: 11, y2025: 10 },
  1917: { y2024: 0, y2025: 0 },
  1918: { y2024: 7, y2025: 8 },
  1919: { y2024: 4, y2025: 8 },
  1920: { y2024: 7, y2025: 8 },
  1921: { y2024: 4, y2025: 8 },
  1922: { y2024: 6, y2025: 8 },
  1923: { y2024: 7, y2025: 8 },
  1924: { y2024: 7, y2025: 8 },
  1925: { y2024: 0, y2025: 0 },
  1926: { y2024: 4, y2025: 4 },
  1928: { y2024: 9, y2025: 9 },
  1930: { y2024: 5, y2025: 5 },
  1931: { y2024: 9, y2025: 12 },
  1932: { y2024: 3, y2025: 3 },
  1933: { y2024: 13, y2025: 13 },
  1934: { y2024: 6, y2025: 6 },
  1935: { y2024: 4, y2025: 4 },
  1936: { y2024: 4, y2025: 5 },
  1937: { y2024: 4, y2025: 4 },
  1939: { y2024: 5, y2025: 6 },
  1940: { y2024: 1, y2025: 1 },
  1942: { y2024: 1, y2025: 1 },
  1943: { y2024: 4, y2025: 3 },
  1945: { y2024: 2, y2025: 2 },
  1946: { y2024: 2, y2025: 2 },
  1947: { y2024: 2, y2025: 3 },
  1948: { y2024: 0, y2025: 0 },
  1949: { y2024: 0, y2025: 0 },
  1950: { y2024: 0, y2025: 0 },
  1951: { y2024: 7, y2025: 8 },
  1952: { y2024: 4, y2025: 8 },
  1953: { y2024: 7, y2025: 8 },
  1954: { y2024: 7, y2025: 8 },
  1955: { y2024: 6, y2025: 6 },
  1957: { y2024: 5, y2025: 5 },
  1959: { y2024: 0, y2025: 0 },
  1960: { y2024: 4, y2025: 3 },
  1961: { y2024: 4, y2025: 3 },
  1962: { y2024: 5, y2025: 2 },
  1963: { y2024: 1, y2025: 1 },
  1964: { y2024: 1, y2025: 1 },
  1965: { y2024: 13, y2025: 10 },
  1966: { y2024: 13, y2025: 10 },
  1968: { y2024: 1, y2025: 1 },
  1969: { y2024: 1, y2025: 1 },
  1971: { y2024: 8, y2025: 8 },
  1972: { y2024: 1, y2025: 1 },
  1973: { y2024: 13, y2025: 13 },
  1974: { y2024: 1, y2025: 1 },
  1975: { y2024: 5, y2025: 5 },
  1976: { y2024: 5, y2025: 5 },
  1979: { y2024: 2, y2025: 2 },
  1980: { y2024: 5, y2025: 6 },
  1981: { y2024: 2, y2025: 2 },
  1982: { y2024: 11, y2025: 10 },
  1983: { y2024: 5, y2025: 5 },
  1984: { y2024: 5, y2025: 6 },
  1985: { y2024: 7, y2025: 8 },
  1986: { y2024: 3, y2025: 2 },
  1987: { y2024: 0, y2025: 0 },
  1988: { y2024: 12, y2025: 9 },
  1989: { y2024: 4, y2025: 4 },
  1992: { y2024: 1, y2025: 1 },
  1994: { y2024: 13, y2025: 9 },
  1995: { y2024: 5, y2025: 2 },
  1998: { y2024: 5, y2025: 5 },
  2000: { y2024: 3, y2025: 4 },
  2001: { y2024: 2, y2025: 2 },
  2003: { y2024: 13, y2025: 13 },
  2004: { y2024: 4, y2025: 2 },
  2005: { y2024: 5, y2025: 6 },
  2007: { y2024: 0, y2025: 0 },
  2008: { y2024: 1, y2025: 1 },
  2010: { y2024: 2, y2025: 2 },
  2011: { y2024: 1, y2025: 1 },
  2012: { y2024: 5, y2025: 5 },
  2013: { y2024: 7, y2025: 4 },
  2014: { y2024: 5, y2025: 5 },
  2015: { y2024: 1, y2025: 1 },
  2016: { y2024: 9, y2025: 12 },
  2017: { y2024: 12, y2025: 11 },
  2018: { y2024: 4, y2025: 4 },
  2019: { y2024: 0, y2025: 0 },
  2022: { y2024: 2, y2025: 5 },
  2023: { y2024: 2, y2025: 3 },
  2025: { y2024: 8, y2025: 8 },
  2027: { y2024: 11, y2025: 10 },
  2028: { y2024: 11, y2025: 10 },
  2029: { y2024: 6, y2025: 7 },
  2030: { y2024: 6, y2025: 6 },
  2031: { y2024: 1, y2025: 1 },
  2033: { y2024: 5, y2025: 5 },
  2034: { y2024: 4, y2025: 5 },
  2035: { y2024: 6, y2025: 7 },
  2037: { y2024: 1, y2025: 1 },
  2038: { y2024: 4, y2025: 2 },
  2039: { y2024: 2, y2025: 2 },
  2040: { y2024: 2, y2025: 2 },
  2042: { y2024: 13, y2025: 13 },
  2043: { y2024: 2, y2025: 2 },
  2044: { y2024: 4, y2025: 4 },
  2045: { y2024: 4, y2025: 5 },
  2046: { y2024: 1, y2025: 1 },
  2047: { y2024: 4, y2025: 4 },
  2048: { y2024: 4, y2025: 4 },
  2049: { y2024: 5, y2025: 7 },
  2050: { y2024: 5, y2025: 7 },
  2051: { y2024: 2, y2025: 2 },
  2052: { y2024: 4, y2025: 2 },
  2054: { y2024: 13, y2025: 9 },
  2055: { y2024: 4, y2025: 4 },
  2056: { y2024: 5, y2025: 6 },
  2057: { y2024: 11, y2025: 10 },
  2058: { y2024: 5, y2025: 5 },
  2059: { y2024: 2, y2025: 2 },
  2060: { y2024: 3, y2025: 3 },
  2064: { y2024: 13, y2025: 13 },
  2065: { y2024: 7, y2025: 8 },
  2068: { y2024: 3, y2025: 3 },
  2069: { y2024: 6, y2025: 7 },
  2070: { y2024: 4, y2025: 4 },
  2073: { y2024: 2, y2025: 2 },
  2074: { y2024: 5, y2025: 7 },
  2078: { y2024: 4, y2025: 5 },
  2079: { y2024: 5, y2025: 5 },
  2081: { y2024: 9, y2025: 9 },
  2082: { y2024: 12, y2025: 9 },
  2089: { y2024: 13, y2025: 13 },
  2090: { y2024: 1, y2025: 1 },
  2091: { y2024: 2, y2025: 2 },
  2092: { y2024: 12, y2025: 9 },
  2093: { y2024: 13, y2025: 9 },
  2094: { y2024: 4, y2025: 4 },
  2095: { y2024: 5, y2025: 5 },
  2096: { y2024: 2, y2025: 2 },
  2097: { y2024: 2, y2025: 4 },
  2098: { y2024: 2, y2025: 2 },
  2099: { y2024: 13, y2025: 13 },
  2100: { y2024: 2, y2025: 2 },
  2101: { y2024: 4, y2025: 4 },
  2103: { y2024: 13, y2025: 10 },
  2104: { y2024: 2, y2025: 2 },
  2105: { y2024: 4, y2025: 4 },
  2108: { y2024: 1, y2025: 1 },
  2109: { y2024: 1, y2025: 1 },
  2110: { y2024: 3, y2025: 2 },
  2111: { y2024: 5, y2025: 4 },
  2113: { y2024: 12, y2025: 9 },
  2114: { y2024: 5, y2025: 6 },
  2115: { y2024: 13, y2025: 13 },
  2116: { y2024: 7, y2025: 7 },
  2117: { y2024: 4, y2025: 4 },
  2118: { y2024: 5, y2025: 6 },
  2119: { y2024: 8, y2025: 6 },
  2121: { y2024: 3, y2025: 2 },
  2122: { y2024: 7, y2025: 8 },
  2123: { y2024: 4, y2025: 4 },
  2124: { y2024: 1, y2025: 1 },
  2125: { y2024: 13, y2025: 9 },
  2126: { y2024: 8, y2025: 6 },
  2128: { y2024: 7, y2025: 8 },
  2130: { y2024: 2, y2025: 4 },
  2131: { y2024: 10, y2025: 10 },
  2132: { y2024: 5, y2025: 5 },
  2133: { y2024: 2, y2025: 2 },
  2134: { y2024: 10, y2025: 5 },
  2135: { y2024: 9, y2025: 9 },
  2136: { y2024: 3, y2025: 2 },
  2137: { y2024: 2, y2025: 2 },
  2138: { y2024: 1, y2025: 1 },
  2139: { y2024: 8, y2025: 8 },
  2140: { y2024: 13, y2025: 9 },
  2141: { y2024: 6, y2025: 6 },
  2142: { y2024: 13, y2025: 9 },
  2143: { y2024: 1, y2025: 1 },
  2144: { y2024: 1, y2025: 1 },
  2145: { y2024: 1, y2025: 1 },
  2146: { y2024: 13, y2025: 9 },
  2147: { y2024: 4, y2025: 2 },
  2148: { y2024: 13, y2025: 9 },
  2152: { y2024: 2, y2025: 2 },
  2153: { y2024: 6, y2025: 6 },
  2154: { y2024: 5, y2025: 3 },
  2155: { y2024: 3, y2025: 3 },
  2156: { y2024: 13, y2025: 10 },
  2157: { y2024: 1, y2025: 1 },
  2159: { y2024: 8, y2025: 10 },
  2160: { y2024: 2, y2025: 2 },
  2161: { y2024: 1, y2025: 1 },
  2162: { y2024: 7, y2025: 9 },
  2163: { y2024: 5, y2025: 6 },
  2164: { y2024: 7, y2025: 9 },
  2165: { y2024: 1, y2025: 1 },
  2167: { y2024: 1, y2025: 1 },
  2168: { y2024: 1, y2025: 1 },
  2169: { y2024: 7, y2025: 7 },
  2170: { y2024: 4, y2025: 5 },
  2171: { y2024: 13, y2025: 9 },
  2172: { y2024: 2, y2025: 3 },
  2173: { y2024: 3, y2025: 3 },
  2174: { y2024: 1, y2025: 1 },
  2175: { y2024: 2, y2025: 2 },
  2176: { y2024: 13, y2025: 9 },
  2177: { y2024: 1, y2025: 1 },
  2178: { y2024: 1, y2025: 1 },
  2179: { y2024: 5, y2025: 5 },
  2180: { y2024: 13, y2025: 9 },
  2181: { y2024: 13, y2025: 9 },
  2182: { y2024: 13, y2025: 9 },
  2183: { y2024: 13, y2025: 9 },
  2184: { y2024: 5, y2025: 6 },
  2185: { y2024: 5, y2025: 6 },
  2189: { y2024: 3, y2025: 3 },
  2190: { y2024: 1, y2025: 1 },
  2191: { y2024: 8, y2025: 8 },
  2193: { y2024: 4, y2025: 2 },
  2195: { y2024: 1, y2025: 1 },
  2197: { y2024: 6, y2025: 7 },
  2198: { y2024: 2, y2025: 2 },
  2199: { y2024: 5, y2025: 2 },
  2200: { y2024: 4, y2025: 4 },
  2201: { y2024: 4, y2025: 4 },
  2202: { y2024: 5, y2025: 7 },
  2203: { y2024: 13, y2025: 13 },
  2204: { y2024: 5, y2025: 7 },
  2208: { y2024: 1, y2025: 1 },
  2210: { y2024: 3, y2025: 3 },
  2212: { y2024: 2, y2025: 2 },
  2213: { y2024: 9, y2025: 9 },
  2214: { y2024: 5, y2025: 2 },
  2215: { y2024: 9, y2025: 7 },
  2216: { y2024: 1, y2025: 1 },
  2217: { y2024: 6, y2025: 7 },
  2218: { y2024: 12, y2025: 9 },
  2219: { y2024: 5, y2025: 6 },
  2220: { y2024: 6, y2025: 6 },
  2221: { y2024: 5, y2025: 4 },
  2222: { y2024: 3, y2025: 2 },
  2224: { y2024: 2, y2025: 2 },
  2226: { y2024: 1, y2025: 1 },
  2227: { y2024: 5, y2025: 2 },
  2228: { y2024: 9, y2025: 9 },
  2231: { y2024: 4, y2025: 4 },
  2232: { y2024: 2, y2025: 3 },
  2233: { y2024: 4, y2025: 3 },
  2234: { y2024: 4, y2025: 3 },
  2235: { y2024: 5, y2025: 4 },
  2236: { y2024: 1, y2025: 1 },
  2237: { y2024: 5, y2025: 5 },
  2238: { y2024: 5, y2025: 6 },
  2239: { y2024: 6, y2025: 6 },
  2240: { y2024: 6, y2025: 7 },
  2241: { y2024: 6, y2025: 7 },
  2242: { y2024: 5, y2025: 6 },
  2243: { y2024: 6, y2025: 5 },
  2244: { y2024: 13, y2025: 9 },
  2245: { y2024: 1, y2025: 2 },
  2246: { y2024: 4, y2025: 2 },
  2247: { y2024: 2, y2025: 3 },
  2248: { y2024: 5, y2025: 2 },
  2249: { y2024: 6, y2025: 5 },
  2250: { y2024: 5, y2025: 6 },
  2251: { y2024: 2, y2025: 2 },
  2252: { y2024: 3, y2025: 2 },
  2253: { y2024: 1, y2025: 1 },
  2254: { y2024: 5, y2025: 6 },
  2255: { y2024: 1, y2025: 2 },
  2256: { y2024: 8, y2025: 8 },
  2257: { y2024: 13, y2025: 13 },
  2258: { y2024: 4, y2025: 4 },
  2259: { y2024: 5, y2025: 5 },
  2260: { y2024: 13, y2025: 13 },
  2261: { y2024: 8, y2025: 9 },
  2262: { y2024: 4, y2025: 4 },
  2263: { y2024: 7, y2025: 9 },
  2264: { y2024: 6, y2025: 11 },
  2265: { y2024: 1, y2025: 1 },
  2266: { y2024: 13, y2025: 13 },
  2267: { y2024: 5, y2025: 5 },
  2268: { y2024: 12, y2025: 9 },
  2269: { y2024: 1, y2025: 1 },
  2270: { y2024: 8, y2025: 6 },
  2271: { y2024: 11, y2025: 10 },
  2272: { y2024: 10, y2025: 10 },
  2274: { y2024: 3, y2025: 3 },
  2275: { y2024: 10, y2025: 10 },
  2276: { y2024: 7, y2025: 8 },
  2277: { y2024: 5, y2025: 6 },
  2278: { y2024: 6, y2025: 6 },
  2279: { y2024: 3, y2025: 4 },
  2280: { y2024: 8, y2025: 8 },
  2281: { y2024: 8, y2025: 6 },
  2283: { y2024: 1, y2025: 1 },
  2284: { y2024: 8, y2025: 6 },
  2285: { y2024: 1, y2025: 2 },
  2286: { y2024: 3, y2025: 3 },
  2287: { y2024: 8, y2025: 6 },
  2288: { y2024: 5, y2025: 5 },
  2289: { y2024: 5, y2025: 5 },
  2290: { y2024: 6, y2025: 6 },
  2291: { y2024: 1, y2025: 2 },
  2292: { y2024: 4, y2025: 4 },
  2293: { y2024: 1, y2025: 1 },
  2296: { y2024: 4, y2025: 5 },
  2298: { y2024: 11, y2025: 9 },
  2299: { y2024: 13, y2025: 13 },
  2300: { y2024: 13, y2025: 13 },
  2301: { y2024: 6, y2025: 6 },
  2302: { y2024: 1, y2025: 1 },
  2303: { y2024: 1, y2025: 1 },
  2304: { y2024: 6, y2025: 6 },
  2305: { y2024: 8, y2025: 6 },
  2306: { y2024: 8, y2025: 6 },
  2307: { y2024: 5, y2025: 5 },
  2308: { y2024: 2, y2025: 2 },
  2309: { y2024: 8, y2025: 6 },
  2310: { y2024: 3, y2025: 4 },
  2311: { y2024: 8, y2025: 8 },
  2312: { y2024: 6, y2025: 6 },
  2316: { y2024: 13, y2025: 9 },
  2317: { y2024: 3, y2025: 2 },
  2318: { y2024: 9, y2025: 9 },
  2319: { y2024: 3, y2025: 2 },
  2320: { y2024: 9, y2025: 9 },
  2321: { y2024: 13, y2025: 8 },
  2322: { y2024: 1, y2025: 1 },
  2323: { y2024: 1, y2025: 1 },
  2324: { y2024: 10, y2025: 7 },
  2325: { y2024: 13, y2025: 10 },
  2326: { y2024: 5, y2025: 5 },
  2327: { y2024: 1, y2025: 1 },
  2328: { y2024: 1, y2025: 1 },
  2329: { y2024: 13, y2025: 13 },
  2330: { y2024: 6, y2025: 7 },
  2332: { y2024: 5, y2025: 5 },
  2333: { y2024: 7, y2025: 9 },
  2337: { y2024: 1, y2025: 2 },
  2338: { y2024: 5, y2025: 2 },
  2339: { y2024: 4, y2025: 3 },
  2340: { y2024: 13, y2025: 13 },
  2341: { y2024: 8, y2025: 5 },
  2342: { y2024: 2, y2025: 3 },
  2344: { y2024: 9, y2025: 7 },
  2345: { y2024: 5, y2025: 5 },
  2346: { y2024: 3, y2025: 2 },
  2347: { y2024: 1, y2025: 1 },
  2348: { y2024: 13, y2025: 8 },
  2351: { y2024: 2, y2025: 2 },
  2352: { y2024: 6, y2025: 6 },
  2353: { y2024: 3, y2025: 4 },
  2355: { y2024: 6, y2025: 6 },
  2356: { y2024: 5, y2025: 5 },
  2357: { y2024: 6, y2025: 7 },
  2359: { y2024: 1, y2025: 1 },
  2360: { y2024: 13, y2025: 13 },
  2361: { y2024: 4, y2025: 5 },
  2362: { y2024: 3, y2025: 5 },
  2363: { y2024: 13, y2025: 13 },
  2364: { y2024: 4, y2025: 5 },
  2365: { y2024: 5, y2025: 5 },
  2369: { y2024: 5, y2025: 5 },
  2370: { y2024: 7, y2025: 9 },
  2371: { y2024: 3, y2025: 2 },
  2372: { y2024: 2, y2025: 2 },
  2373: { y2024: 13, y2025: 13 },
  2374: { y2024: 9, y2025: 11 },
  2375: { y2024: 2, y2025: 2 },
  2376: { y2024: 5, y2025: 4 },
  2377: { y2024: 3, y2025: 3 },
  2378: { y2024: 6, y2025: 7 },
  2381: { y2024: 2, y2025: 2 },
  2382: { y2024: 8, y2025: 6 },
  2383: { y2024: 7, y2025: 9 },
  2384: { y2024: 4, y2025: 5 },
  2385: { y2024: 11, y2025: 11 },
  2386: { y2024: 5, y2025: 5 },
  2388: { y2024: 5, y2025: 5 },
  2389: { y2024: 3, y2025: 3 },
  2390: { y2024: 2, y2025: 2 },
  2391: { y2024: 5, y2025: 5 },
  2392: { y2024: 7, y2025: 8 },
  2393: { y2024: 13, y2025: 9 },
  2394: { y2024: 8, y2025: 7 },
  2395: { y2024: 5, y2025: 6 },
  2396: { y2024: 5, y2025: 5 },
  2397: { y2024: 5, y2025: 6 },
  2398: { y2024: 5, y2025: 5 },
  2399: { y2024: 8, y2025: 7 },
  2400: { y2024: 7, y2025: 9 },
  2401: { y2024: 5, y2025: 5 },
  2402: { y2024: 4, y2025: 4 },
  2403: { y2024: 6, y2025: 6 },
  2404: { y2024: 4, y2025: 4 },
  2407: { y2024: 13, y2025: 13 },
  2408: { y2024: 1, y2025: 1 },
  2409: { y2024: 2, y2025: 2 },
  2410: { y2024: 13, y2025: 9 },
  2413: { y2024: 1, y2025: 1 },
  2417: { y2024: 2, y2025: 3 },
  2418: { y2024: 4, y2025: 6 },
  2419: { y2024: 13, y2025: 13 },
  2420: { y2024: 13, y2025: 13 },
  2421: { y2024: 3, y2025: 5 },
  2422: { y2024: 1, y2025: 4 },
  2423: { y2024: 1, y2025: 1 },
  2424: { y2024: 1, y2025: 1 },
  2426: { y2024: 13, y2025: 10 },
  2427: { y2024: 1, y2025: 1 },
  2429: { y2024: 4, y2025: 4 },
  2431: { y2024: 1, y2025: 1 },
  2432: { y2024: 2, y2025: 2 },
  2434: { y2024: 4, y2025: 6 },
  2435: { y2024: 6, y2025: 6 },
  2437: { y2024: 5, y2025: 5 },
  2438: { y2024: 1, y2025: 1 },
  2439: { y2024: 1, y2025: 2 },
  2440: { y2024: 5, y2025: 5 },
  2441: { y2024: 1, y2025: 1 },
  2442: { y2024: 5, y2025: 5 },
  2443: { y2024: 9, y2025: 11 },
  2444: { y2024: 5, y2025: 5 },
  2445: { y2024: 2, y2025: 2 },
  2446: { y2024: 4, y2025: 4 },
  2447: { y2024: 5, y2025: 5 },
  2448: { y2024: 1, y2025: 1 },
  2449: { y2024: 5, y2025: 4 },
  2450: { y2024: 6, y2025: 7 },
  2451: { y2024: 5, y2025: 5 },
  2452: { y2024: 11, y2025: 10 },
  2454: { y2024: 5, y2025: 5 },
  2455: { y2024: 10, y2025: 10 },
  2456: { y2024: 4, y2025: 4 },
  2457: { y2024: 12, y2025: 9 },
  2458: { y2024: 7, y2025: 9 },
  2460: { y2024: 2, y2025: 2 },
  2461: { y2024: 3, y2025: 4 },
  2462: { y2024: 4, y2025: 5 },
  2463: { y2024: 5, y2025: 5 },
  2464: { y2024: 5, y2025: 5 },
  2465: { y2024: 5, y2025: 5 },
  2466: { y2024: 5, y2025: 5 },
  2467: { y2024: 5, y2025: 5 },
  2468: { y2024: 7, y2025: 9 },
  2469: { y2024: 1, y2025: 1 },
  2470: { y2024: 1, y2025: 1 },
  2471: { y2024: 4, y2025: 4 },
  2472: { y2024: 1, y2025: 1 },
  2473: { y2024: 4, y2025: 4 },
  2474: { y2024: 4, y2025: 5 },
  2483: { y2024: 3, y2025: 3 },
  2485: { y2024: 6, y2025: 6 },
  2486: { y2024: 1, y2025: 1 },
  2487: { y2024: 5, y2025: 5 },
  2489: { y2024: 5, y2025: 5 },
  2490: { y2024: 7, y2025: 9 },
  2491: { y2024: 5, y2025: 5 },
  2492: { y2024: 8, y2025: 6 },
  2493: { y2024: 11, y2025: 10 },
  2494: { y2024: 13, y2025: 13 },
  2495: { y2024: 13, y2025: 13 },
  2497: { y2024: 1, y2025: 1 },
  2498: { y2024: 2, y2025: 2 },
  2499: { y2024: 13, y2025: 13 },
  2500: { y2024: 4, y2025: 5 },
  2501: { y2024: 3, y2025: 4 },
  2502: { y2024: 7, y2025: 9 },
  2503: { y2024: 6, y2025: 6 },
  2504: { y2024: 11, y2025: 10 },
  2505: { y2024: 13, y2025: 13 },
  2508: { y2024: 5, y2025: 7 },
  2509: { y2024: 5, y2025: 7 },
  2510: { y2024: 2, y2025: 2 },
  2512: { y2024: 2, y2025: 2 },
  2513: { y2024: 1, y2025: 1 },
  2515: { y2024: 4, y2025: 5 },
  2516: { y2024: 2, y2025: 2 },
  2517: { y2024: 13, y2025: 9 },
  2518: { y2024: 2, y2025: 2 },
  2520: { y2024: 1, y2025: 1 },
  2522: { y2024: 5, y2025: 7 },
  2523: { y2024: 4, y2025: 4 },
  2524: { y2024: 3, y2025: 3 },
  2525: { y2024: 13, y2025: 13 },
  2526: { y2024: 3, y2025: 3 },
  2527: { y2024: 10, y2025: 5 },
  2528: { y2024: 3, y2025: 4 },
  2529: { y2024: 0, y2025: 0 },
  2530: { y2024: 1, y2025: 3 },
  2531: { y2024: 2, y2025: 2 },
  2532: { y2024: 3, y2025: 3 },
  2533: { y2024: 1, y2025: 1 },
  2534: { y2024: 13, y2025: 13 },
  2536: { y2024: 6, y2025: 7 },
  2537: { y2024: 4, y2025: 4 },
  2538: { y2024: 4, y2025: 4 },
  2539: { y2024: 11, y2025: 10 },
  2540: { y2024: 6, y2025: 7 },
  2541: { y2024: 4, y2025: 4 },
  2542: { y2024: 1, y2025: 1 },
  2543: { y2024: 1, y2025: 1 },
  2544: { y2024: 5, y2025: 7 },
  2545: { y2024: 7, y2025: 9 },
  2548: { y2024: 5, y2025: 5 },
  2549: { y2024: 6, y2025: 7 },
  2550: { y2024: 6, y2025: 6 },
  2552: { y2024: 5, y2025: 6 },
  2553: { y2024: 5, y2025: 5 },
  2555: { y2024: 6, y2025: 7 },
  2556: { y2024: 4, y2025: 4 },
  2557: { y2024: 1, y2025: 1 },
  2558: { y2024: 2, y2025: 2 },
  2560: { y2024: 8, y2025: 6 },
  2561: { y2024: 1, y2025: 1 },
  2562: { y2024: 7, y2025: 9 },
  2563: { y2024: 3, y2025: 2 },
  2564: { y2024: 10, y2025: 10 },
  2565: { y2024: 11, y2025: 10 },
  2566: { y2024: 1, y2025: 1 },
  2567: { y2024: 2, y2025: 2 },
  2568: { y2024: 3, y2025: 5 },
  2569: { y2024: 8, y2025: 6 },
  2570: { y2024: 4, y2025: 5 },
  2571: { y2024: 4, y2025: 4 },
  2572: { y2024: 5, y2025: 5 },
  2573: { y2024: 1, y2025: 1 },
  2574: { y2024: 5, y2025: 5 },
  2575: { y2024: 13, y2025: 13 },
  2576: { y2024: 3, y2025: 3 },
  2577: { y2024: 4, y2025: 4 },
  2578: { y2024: 9, y2025: 9 },
  2579: { y2024: 13, y2025: 10 },
  2580: { y2024: 5, y2025: 5 },
  2581: { y2024: 1, y2025: 1 },
  2582: { y2024: 1, y2025: 2 },
  2583: { y2024: 1, y2025: 1 },
  2584: { y2024: 13, y2025: 13 },
  2585: { y2024: 11, y2025: 10 },
  2588: { y2024: 1, y2025: 1 },
  2589: { y2024: 5, y2025: 5 },
  2590: { y2024: 5, y2025: 5 },
  2591: { y2024: 4, y2025: 6 },
  2592: { y2024: 2, y2025: 2 },
  2593: { y2024: 9, y2025: 8 },
  2594: { y2024: 3, y2025: 3 },
  2595: { y2024: 4, y2025: 4 },
  2596: { y2024: 4, y2025: 4 },
  2597: { y2024: 4, y2025: 4 },
  2598: { y2024: 2, y2025: 2 },
  2599: { y2024: 2, y2025: 2 },
  2600: { y2024: 5, y2025: 6 },
  2601: { y2024: 13, y2025: 10 },
  2602: { y2024: 4, y2025: 5 },
  2603: { y2024: 1, y2025: 1 },
  2604: { y2024: 4, y2025: 4 },
  2606: { y2024: 7, y2025: 7 },
  2607: { y2024: 3, y2025: 3 },
  2608: { y2024: 2, y2025: 2 },
  2609: { y2024: 3, y2025: 3 },
  2610: { y2024: 4, y2025: 6 },
  2611: { y2024: 1, y2025: 1 },
  2612: { y2024: 1, y2025: 1 },
  2614: { y2024: 6, y2025: 6 },
  2615: { y2024: 5, y2025: 5 },
  2616: { y2024: 5, y2025: 6 },
  2617: { y2024: 13, y2025: 9 },
  2618: { y2024: 12, y2025: 9 },
  2619: { y2024: 1, y2025: 1 },
  2621: { y2024: 12, y2025: 9 },
  2622: { y2024: 6, y2025: 6 },
  2623: { y2024: 7, y2025: 9 },
  2624: { y2024: 1, y2025: 1 },
  2625: { y2024: 1, y2025: 2 },
  2626: { y2024: 4, y2025: 5 },
  2627: { y2024: 9, y2025: 8 },
  2628: { y2024: 7, y2025: 7 },
  2629: { y2024: 13, y2025: 13 },
  2631: { y2024: 5, y2025: 5 },
  2632: { y2024: 5, y2025: 5 },
  2633: { y2024: 4, y2025: 5 },
  2634: { y2024: 1, y2025: 1 },
  2635: { y2024: 2, y2025: 2 },
  2636: { y2024: 5, y2025: 6 },
  2637: { y2024: 13, y2025: 9 },
  2639: { y2024: 3, y2025: 3 },
  2640: { y2024: 1, y2025: 1 },
  2641: { y2024: 12, y2025: 8 },
  2642: { y2024: 1, y2025: 1 },
  2643: { y2024: 5, y2025: 5 },
  2645: { y2024: 13, y2025: 9 },
  2646: { y2024: 13, y2025: 9 },
  2647: { y2024: 5, y2025: 6 },
  2648: { y2024: 13, y2025: 9 },
  2650: { y2024: 1, y2025: 1 },
  2651: { y2024: 1, y2025: 1 },
  2652: { y2024: 1, y2025: 1 },
  2653: { y2024: 7, y2025: 7 },
  2654: { y2024: 3, y2025: 3 },
  2655: { y2024: 11, y2025: 7 },
  2656: { y2024: 9, y2025: 8 },
  2657: { y2024: 4, y2025: 5 },
  2658: { y2024: 1, y2025: 1 },
  2659: { y2024: 2, y2025: 2 },
  2660: { y2024: 13, y2025: 9 },
  2662: { y2024: 5, y2025: 6 },
  2664: { y2024: 5, y2025: 5 },
  2665: { y2024: 13, y2025: 13 },
  2666: { y2024: 3, y2025: 4 },
  2668: { y2024: 11, y2025: 10 },
  2669: { y2024: 1, y2025: 1 },
  2670: { y2024: 4, y2025: 4 },
  2671: { y2024: 6, y2025: 5 },
  2672: { y2024: 1, y2025: 1 },
  2673: { y2024: 3, y2025: 3 },
  2674: { y2024: 3, y2025: 3 },
  2675: { y2024: 1, y2025: 1 },
  2676: { y2024: 1, y2025: 1 },
  2677: { y2024: 1, y2025: 1 },
  2678: { y2024: 1, y2025: 4 },
  2679: { y2024: 2, y2025: 2 },
  2680: { y2024: 6, y2025: 5 },
  2682: { y2024: 5, y2025: 5 },
  2683: { y2024: 4, y2025: 4 },
  2684: { y2024: 9, y2025: 9 },
  2685: { y2024: 4, y2025: 4 },
  2686: { y2024: 2, y2025: 2 },
  2687: { y2024: 2, y2025: 3 },
  2688: { y2024: 5, y2025: 5 },
  2689: { y2024: 13, y2025: 13 },
  2690: { y2024: 4, y2025: 4 },
  2691: { y2024: 1, y2025: 1 },
  2692: { y2024: 9, y2025: 9 },
  2693: { y2024: 3, y2025: 3 },
  2694: { y2024: 1, y2025: 1 },
  2695: { y2024: 2, y2025: 2 },
  2697: { y2024: 4, y2025: 5 },
  2699: { y2024: 6, y2025: 7 },
  2700: { y2024: 1, y2025: 1 },
  2701: { y2024: 12, y2025: 9 },
  2702: { y2024: 1, y2025: 1 },
  2703: { y2024: 6, y2025: 7 },
  2704: { y2024: 5, y2025: 5 },
  2705: { y2024: 7, y2025: 9 },
  2706: { y2024: 12, y2025: 9 },
  2707: { y2024: 4, y2025: 4 },
  2708: { y2024: 2, y2025: 2 },
  2710: { y2024: 4, y2025: 4 },
  2711: { y2024: 12, y2025: 11 },
  2712: { y2024: 11, y2025: 10 },
  2713: { y2024: 9, y2025: 9 },
  2714: { y2024: 11, y2025: 10 },
  2715: { y2024: 4, y2025: 4 },
  2716: { y2024: 3, y2025: 2 },
  2717: { y2024: 13, y2025: 10 },
  2718: { y2024: 10, y2025: 5 },
  2719: { y2024: 2, y2025: 2 },
  2720: { y2024: 9, y2025: 8 },
  2721: { y2024: 0, y2025: 1 },
  2722: { y2024: 3, y2025: 2 },
  2723: { y2024: 13, y2025: 13 },
  2724: { y2024: 1, y2025: 2 },
  2725: { y2024: 3, y2025: 3 },
  2726: { y2024: 3, y2025: 5 },
  2727: { y2024: 1, y2025: 1 },
  2728: { y2024: 4, y2025: 4 },
  2729: { y2024: 11, y2025: 10 },
  2730: { y2024: 4, y2025: 4 },
  2731: { y2024: 4, y2025: 4 },
  2732: { y2024: 4, y2025: 4 },
  2733: { y2024: 1, y2025: 1 },
  2734: { y2024: 5, y2025: 6 },
  2735: { y2024: 1, y2025: 1 },
  2736: { y2024: 1, y2025: 1 },
  2737: { y2024: 2, y2025: 2 },
  2739: { y2024: 4, y2025: 4 },
  2740: { y2024: 5, y2025: 5 },
  2741: { y2024: 2, y2025: 2 },
  2742: { y2024: 2, y2025: 2 },
  2743: { y2024: 4, y2025: 4 },
  2744: { y2024: 8, y2025: 5 },
  2745: { y2024: 3, y2025: 3 },
  2746: { y2024: 1, y2025: 1 },
  2747: { y2024: 1, y2025: 1 },
  2748: { y2024: 2, y2025: 2 },
  2749: { y2024: 3, y2025: 3 },
  2750: { y2024: 2, y2025: 2 },
  2751: { y2024: 1, y2025: 1 },
  2752: { y2024: 2, y2025: 2 },
  2753: { y2024: 0, y2025: 9 },
  2754: { y2024: 4, y2025: 5 },
  2755: { y2024: 4, y2025: 4 },
  2756: { y2024: 4, y2025: 4 },
  2757: { y2024: 1, y2025: 1 },
  2758: { y2024: 4, y2025: 4 },
  2759: { y2024: 13, y2025: 13 },
  2760: { y2024: 3, y2025: 4 },
  2761: { y2024: 13, y2025: 9 },
  2762: { y2024: 7, y2025: 7 },
  2763: { y2024: 1, y2025: 1 },
  2764: { y2024: 13, y2025: 13 },
  2765: { y2024: 5, y2025: 7 },
  2766: { y2024: 8, y2025: 5 },
  2767: { y2024: 5, y2025: 2 },
  2770: { y2024: 13, y2025: 13 },
  2771: { y2024: 5, y2025: 5 },
  2772: { y2024: 5, y2025: 6 },
  2773: { y2024: 5, y2025: 5 },
  2774: { y2024: 1, y2025: 1 },
  2775: { y2024: 1, y2025: 1 },
  2776: { y2024: 1, y2025: 1 },
  2778: { y2024: 4, y2025: 4 },
  2779: { y2024: 3, y2025: 3 },
  2780: { y2024: 4, y2025: 4 },
  2781: { y2024: 3, y2025: 5 },
  2782: { y2024: 4, y2025: 4 },
  2783: { y2024: 7, y2025: 8 },
  2784: { y2024: 5, y2025: 5 },
  2785: { y2024: 4, y2025: 4 },
  2786: { y2024: 2, y2025: 2 },
  2789: { y2024: 5, y2025: 6 },
  2790: { y2024: 3, y2025: 3 },
  2791: { y2024: 3, y2025: 3 },
  2792: { y2024: 7, y2025: 7 },
  2793: { y2024: 1, y2025: 1 },
  2794: { y2024: 2, y2025: 2 },
  2795: { y2024: 5, y2025: 5 },
  2796: { y2024: 5, y2025: 5 },
  2797: { y2024: 4, y2025: 4 },
  2798: { y2024: 2, y2025: 2 },
  2800: { y2024: 10, y2025: 10 },
  2801: { y2024: 12, y2025: 9 },
  2802: { y2024: 4, y2025: 4 },
  2803: { y2024: 5, y2025: 5 },
  2804: { y2024: 11, y2025: 9 },
  2805: { y2024: 5, y2025: 6 },
  2806: { y2024: 3, y2025: 4 },
  2807: { y2024: 2, y2025: 2 },
  2808: { y2024: 6, y2025: 6 },
  2810: { y2024: 4, y2025: 4 },
  2811: { y2024: 5, y2025: 5 },
  2813: { y2024: 6, y2025: 7 },
  2814: { y2024: 9, y2025: 12 },
  2815: { y2024: 4, y2025: 4 },
  2816: { y2024: 5, y2025: 5 },
  2817: { y2024: 9, y2025: 9 },
  2818: { y2024: 7, y2025: 9 },
  2819: { y2024: 4, y2025: 4 },
  2820: { y2024: 13, y2025: 13 },
  2821: { y2024: 13, y2025: 13 },
  2822: { y2024: 2, y2025: 2 },
  2824: { y2024: 0, y2025: 4 },
  2825: { y2024: 0, y2025: 2 },
  2826: { y2024: 0, y2025: 4 },
  2827: { y2024: 0, y2025: 4 },
  2828: { y2024: 0, y2025: 8 },
  2829: { y2024: 0, y2025: 4 },
  2830: { y2024: 0, y2025: 4 },
  2831: { y2024: 0, y2025: 3 },
  2832: { y2024: 0, y2025: 5 },
  2833: { y2024: 0, y2025: 1 },
  2835: { y2024: 0, y2025: 9 },
  2836: { y2024: 0, y2025: 2 },
  2837: { y2024: 0, y2025: 2 },
  2838: { y2024: 0, y2025: 1 },
  2839: { y2024: 0, y2025: 1 },
  2840: { y2024: 0, y2025: 4 },
  2841: { y2024: 0, y2025: 1 },
  2842: { y2024: 0, y2025: 4 },
  2843: { y2024: 0, y2025: 7 },
  2844: { y2024: 0, y2025: 3 },
  2845: { y2024: 0, y2025: 5 },
  2846: { y2024: 0, y2025: 5 },
  2847: { y2024: 0, y2025: 1 },
  2848: { y2024: 0, y2025: 1 },
  2849: { y2024: 0, y2025: 7 },
  2850: { y2024: 0, y2025: 5 },
  2851: { y2024: 0, y2025: 5 },
  2852: { y2024: 0, y2025: 9 },
  2853: { y2024: 0, y2025: 4 },
  2855: { y2024: 0, y2025: 13 },
  2856: { y2024: 0, y2025: 11 },
  2857: { y2024: 0, y2025: 9 },
  2858: { y2024: 0, y2025: 13 },
  2859: { y2024: 0, y2025: 3 },
  2860: { y2024: 0, y2025: 3 },
  2861: { y2024: 0, y2025: 0 },
  2862: { y2024: 0, y2025: 5 },
  2864: { y2024: 0, y2025: 8 },
  2865: { y2024: 0, y2025: 2 },
  2866: { y2024: 0, y2025: 4 },
  2867: { y2024: 0, y2025: 6 },
  2868: { y2024: 0, y2025: 2 },
  2869: { y2024: 0, y2025: 1 },
  2870: { y2024: 0, y2025: 5 },
  2871: { y2024: 0, y2025: 6 },
  2872: { y2024: 0, y2025: 4 },
  2873: { y2024: 0, y2025: 4 },
  2874: { y2024: 0, y2025: 5 },
  2875: { y2024: 0, y2025: 5 },
  2876: { y2024: 0, y2025: 2 },
  2877: { y2024: 0, y2025: 5 },
  2878: { y2024: 0, y2025: 1 },
  2879: { y2024: 0, y2025: 7 },
  2880: { y2024: 0, y2025: 4 },
  2881: { y2024: 0, y2025: 13 },
  2882: { y2024: 0, y2025: 1 },
  2883: { y2024: 0, y2025: 1 },
  2884: { y2024: 0, y2025: 13 },
  2885: { y2024: 5, y2025: 4 },
  2886: { y2024: 0, y2025: 5 },
  2888: { y2024: 0, y2025: 1 },
  2889: { y2024: 0, y2025: 1 },
  2890: { y2024: 0, y2025: 1 },
  2891: { y2024: 9, y2025: 6 },
  2892: { y2024: 0, y2025: 2 },
  2893: { y2024: 0, y2025: 13 },
  2894: { y2024: 0, y2025: 2 },
  2895: { y2024: 0, y2025: 13 },
  2896: { y2024: 0, y2025: 4 },
  2897: { y2024: 0, y2025: 3 },
  2898: { y2024: 0, y2025: 5 },
  2899: { y2024: 0, y2025: 3 },
  2900: { y2024: 0, y2025: 5 },
  2901: { y2024: 0, y2025: 1 },
  2902: { y2024: 0, y2025: 3 },
  2903: { y2024: 0, y2025: 5 },
  2905: { y2024: 0, y2025: 5 },
  2906: { y2024: 0, y2025: 1 },
  2907: { y2024: 0, y2025: 4 },
  2909: { y2024: 0, y2025: 1 },
  2910: { y2024: 0, y2025: 10 },
  2911: { y2024: 0, y2025: 6 },
  2913: { y2024: 0, y2025: 5 },
  2914: { y2024: 0, y2025: 6 },
  2915: { y2024: 0, y2025: 6 },
  2916: { y2024: 0, y2025: 7 },
  2918: { y2024: 0, y2025: 5 },
  2919: { y2024: 0, y2025: 1 },
  2920: { y2024: 0, y2025: 2 },
  2922: { y2024: 0, y2025: 13 },
  2923: { y2024: 0, y2025: 3 },
  2924: { y2024: 0, y2025: 2 },
  2925: { y2024: 0, y2025: 2 },
  2926: { y2024: 0, y2025: 4 },
  2927: { y2024: 0, y2025: 2 },
  2928: { y2024: 0, y2025: 4 },
  2931: { y2024: 0, y2025: 7 },
  2932: { y2024: 0, y2025: 7 },
  2933: { y2024: 0, y2025: 1 },
  2934: { y2024: 0, y2025: 5 },
  2935: { y2024: 0, y2025: 6 },
  2938: { y2024: 0, y2025: 5 },
  2940: { y2024: 0, y2025: 6 },
  2941: { y2024: 0, y2025: 11 },
  2942: { y2024: 0, y2025: 1 },
  2943: { y2024: 0, y2025: 1 },
  2944: { y2024: 0, y2025: 2 },
  2946: { y2024: 0, y2025: 4 },
  2947: { y2024: 2, y2025: 1 },
  2948: { y2024: 0, y2025: 4 },
  2949: { y2024: 0, y2025: 6 },
  2950: { y2024: 0, y2025: 1 },
  2951: { y2024: 0, y2025: 5 },
  2952: { y2024: 0, y2025: 2 },
  2953: { y2024: 0, y2025: 6 },
  2954: { y2024: 2, y2025: 2 },
  2956: { y2024: 0, y2025: 7 },
  2957: { y2024: 0, y2025: 4 },
  2958: { y2024: 0, y2025: 6 },
  2959: { y2024: 0, y2025: 6 },
  2960: { y2024: 0, y2025: 1 },
  2961: { y2024: 0, y2025: 2 },
  2964: { y2024: 5, y2025: 5 },
  2966: { y2024: 0, y2025: 2 },
  2967: { y2024: 0, y2025: 5 },
  2968: { y2024: 0, y2025: 9 },
  2969: { y2024: 0, y2025: 7 },
  2970: { y2024: 0, y2025: 6 },
  2971: { y2024: 0, y2025: 13 },
  2972: { y2024: 0, y2025: 13 },
  2973: { y2024: 0, y2025: 4 },
  2974: { y2024: 0, y2025: 8 },
  2977: { y2024: 0, y2025: 2 },
  2978: { y2024: 0, y2025: 1 },
  2979: { y2024: 0, y2025: 0 },
  2980: { y2024: 0, y2025: 1 },
  2981: { y2024: 0, y2025: 1 },
  2982: { y2024: 0, y2025: 4 },
  2983: { y2024: 0, y2025: 2 },
  2984: { y2024: 0, y2025: 8 },
  2985: { y2024: 0, y2025: 3 },
  2986: { y2024: 0, y2025: 5 },
  2987: { y2024: 0, y2025: 13 },
  2988: { y2024: 0, y2025: 13 },
  2989: { y2024: 0, y2025: 13 },
  2990: { y2024: 0, y2025: 13 },
  2991: { y2024: 0, y2025: 13 },
  2992: { y2024: 0, y2025: 13 },
  2993: { y2024: 0, y2025: 1 },
  2994: { y2024: 0, y2025: 1 },
  2995: { y2024: 0, y2025: 5 },
  2996: { y2024: 0, y2025: 13 },
  2997: { y2024: 0, y2025: 13 },
  2999: { y2024: 0, y2025: 7 },
  3001: { y2024: 0, y2025: 7 },
  3002: { y2024: 0, y2025: 8 },
  3003: { y2024: 0, y2025: 3 },
  3004: { y2024: 0, y2025: 7 },
  3005: { y2024: 0, y2025: 2 },
  3006: { y2024: 0, y2025: 6 },
  3007: { y2024: 0, y2025: 1 },
  3008: { y2024: 0, y2025: 13 },
  3009: { y2024: 6, y2025: 2 },
  3010: { y2024: 0, y2025: 6 },
  3012: { y2024: 0, y2025: 1 },
  3013: { y2024: 0, y2025: 2 },
  3014: { y2024: 0, y2025: 5 },
  3015: { y2024: 0, y2025: 7 },
  3016: { y2024: 0, y2025: 1 },
  3017: { y2024: 0, y2025: 1 },
  3018: { y2024: 0, y2025: 6 },
  3019: { y2024: 0, y2025: 1 },
  3020: { y2024: 0, y2025: 4 },
  3021: { y2024: 0, y2025: 1 },
  3022: { y2024: 0, y2025: 13 },
  3023: { y2024: 0, y2025: 5 },
  3025: { y2024: 0, y2025: 8 },
  3026: { y2024: 0, y2025: 3 },
  3027: { y2024: 0, y2025: 4 },
  3028: { y2024: 0, y2025: 1 },
  3029: { y2024: 0, y2025: 5 },
  3030: { y2024: 0, y2025: 13 },
  3031: { y2024: 0, y2025: 8 },
  3032: { y2024: 0, y2025: 1 },
  3033: { y2024: 0, y2025: 4 },
  3034: { y2024: 0, y2025: 1 },
  3036: { y2024: 0, y2025: 1 },
  3037: { y2024: 0, y2025: 1 },
  3038: { y2024: 0, y2025: 1 },
  3039: { y2024: 0, y2025: 5 },
  3040: { y2024: 0, y2025: 6 },
  3041: { y2024: 0, y2025: 6 },
  3042: { y2024: 0, y2025: 9 },
  3043: { y2024: 0, y2025: 9 },
  3044: { y2024: 0, y2025: 4 },
  3045: { y2024: 0, y2025: 5 },
  3046: { y2024: 1, y2025: 9 },
  3047: { y2024: 0, y2025: 4 },
  3048: { y2024: 0, y2025: 4 },
  3049: { y2024: 0, y2025: 5 },
  3050: { y2024: 0, y2025: 5 },
  3052: { y2024: 0, y2025: 4 },
  3053: { y2024: 0, y2025: 10 },
  3054: { y2024: 0, y2025: 1 },
  3055: { y2024: 0, y2025: 3 },
  3056: { y2024: 0, y2025: 6 },
  3057: { y2024: 0, y2025: 13 },
  3058: { y2024: 0, y2025: 9 },
  3059: { y2024: 0, y2025: 8 },
  3060: { y2024: 0, y2025: 4 },
  3061: { y2024: 0, y2025: 6 },
  3062: { y2024: 0, y2025: 3 },
  3063: { y2024: 0, y2025: 5 },
  3065: { y2024: 0, y2025: 6 },
  3066: { y2024: 0, y2025: 2 },
  3067: { y2024: 0, y2025: 1 },
  3068: { y2024: 0, y2025: 2 },
  3069: { y2024: 0, y2025: 8 },
  3070: { y2024: 0, y2025: 13 },
  3071: { y2024: 0, y2025: 2 },
  3072: { y2024: 3, y2025: 9 },
  3073: { y2024: 0, y2025: 1 },
  3074: { y2024: 0, y2025: 1 },
  3075: { y2024: 0, y2025: 5 },
  3076: { y2024: 0, y2025: 3 },
  3077: { y2024: 0, y2025: 13 },
  3078: { y2024: 0, y2025: 5 },
  3079: { y2024: 0, y2025: 6 },
  3080: { y2024: 0, y2025: 10 },
  3081: { y2024: 0, y2025: 4 },
  3082: { y2024: 0, y2025: 13 },
  3083: { y2024: 0, y2025: 7 },
  3084: { y2024: 0, y2025: 4 },
  3085: { y2024: 0, y2025: 4 },
  3086: { y2024: 0, y2025: 13 },
  3087: { y2024: 0, y2025: 1 },
  3088: { y2024: 0, y2025: 1 },
  3089: { y2024: 0, y2025: 1 },
  3090: { y2024: 0, y2025: 13 },
  3091: { y2024: 0, y2025: 6 },
  3092: { y2024: 0, y2025: 7 },
  3093: { y2024: 0, y2025: 7 },
  3094: { y2024: 0, y2025: 7 },
  3095: { y2024: 0, y2025: 7 },
  3096: { y2024: 0, y2025: 1 },
  3097: { y2024: 0, y2025: 1 },
  3098: { y2024: 0, y2025: 6 },
  3099: { y2024: 0, y2025: 13 },
  3100: { y2024: 0, y2025: 1 },
  3101: { y2024: 0, y2025: 7 },
  3103: { y2024: 0, y2025: 4 },
  3104: { y2024: 0, y2025: 1 },
  3105: { y2024: 0, y2025: 7 },
  3107: { y2024: 0, y2025: 5 },
  3108: { y2024: 0, y2025: 7 },
  3109: { y2024: 0, y2025: 7 },
  3110: { y2024: 0, y2025: 7 },
  3111: { y2024: 0, y2025: 7 },
  3112: { y2024: 0, y2025: 6 },
  3113: { y2024: 0, y2025: 7 },
  3114: { y2024: 6, y2025: 3 },
  3115: { y2024: 0, y2025: 7 },
  3116: { y2024: 0, y2025: 7 },
  3117: { y2024: 0, y2025: 1 },
  3118: { y2024: 0, y2025: 1 },
  3119: { y2024: 0, y2025: 7 },
  3120: { y2024: 0, y2025: 6 },
  3121: { y2024: 0, y2025: 2 },
  3122: { y2024: 0, y2025: 6 },
  3123: { y2024: 0, y2025: 6 },
  3124: { y2024: 0, y2025: 13 },
  3125: { y2024: 0, y2025: 5 },
  3126: { y2024: 0, y2025: 7 },
  3127: { y2024: 0, y2025: 1 },
  3128: { y2024: 0, y2025: 2 },
  3129: { y2024: 0, y2025: 6 },
  3130: { y2024: 0, y2025: 1 },
  3131: { y2024: 0, y2025: 1 },
  3132: { y2024: 0, y2025: 2 },
  3133: { y2024: 0, y2025: 3 },
  3134: { y2024: 0, y2025: 13 },
  3135: { y2024: 0, y2025: 8 },
  3136: { y2024: 0, y2025: 1 },
  3137: { y2024: 0, y2025: 1 },
  3138: { y2024: 0, y2025: 5 },
  3139: { y2024: 0, y2025: 6 },
  3140: { y2024: 0, y2025: 3 },
  3141: { y2024: 0, y2025: 1 },
  3142: { y2024: 2, y2025: 5 },
  3143: { y2024: 0, y2025: 2 },
  3145: { y2024: 0, y2025: 3 },
  3146: { y2024: 0, y2025: 13 },
  3147: { y2024: 0, y2025: 1 },
  3148: { y2024: 0, y2025: 13 },
  3149: { y2024: 0, y2025: 1 },
  3150: { y2024: 0, y2025: 2 },
  3151: { y2024: 7, y2025: 9 },
  3152: { y2024: 0, y2025: 3 },
  3153: { y2024: 0, y2025: 0 },
  3154: { y2024: 0, y2025: 0 },
  3155: { y2024: 0, y2025: 0 },
  3156: { y2024: 0, y2025: 0 },
  3158: { y2024: 0, y2025: 0 },
  3159: { y2024: 4, y2025: 4 },
  3160: { y2024: 0, y2025: 0 },
  3161: { y2024: 2, y2025: 2 },
  3162: { y2024: 0, y2025: 0 },
  3163: { y2024: 0, y2025: 0 },
  3164: { y2024: 0, y2025: 0 },
  3166: { y2024: 0, y2025: 0 },
  3167: { y2024: 0, y2025: 0 },
  3168: { y2024: 0, y2025: 0 },
  3169: { y2024: 0, y2025: 0 },
  3170: { y2024: 0, y2025: 0 },
  3171: { y2024: 0, y2025: 0 },
  3172: { y2024: 0, y2025: 0 },
  3173: { y2024: 0, y2025: 0 },
  3174: { y2024: 0, y2025: 0 },
  3175: { y2024: 0, y2025: 0 },
  3176: { y2024: 0, y2025: 0 },
  3177: { y2024: 0, y2025: 0 },
  3178: { y2024: 0, y2025: 0 },
  3179: { y2024: 0, y2025: 0 },
  3180: { y2024: 0, y2025: 0 },
  3181: { y2024: 0, y2025: 0 },
  3182: { y2024: 0, y2025: 0 },
  3183: { y2024: 0, y2025: 0 },
  3184: { y2024: 0, y2025: 0 },
  3185: { y2024: 0, y2025: 0 },
  3186: { y2024: 0, y2025: 0 },
  3187: { y2024: 0, y2025: 0 },
  3188: { y2024: 0, y2025: 0 },
  3189: { y2024: 0, y2025: 0 },
  3190: { y2024: 0, y2025: 0 },
  3191: { y2024: 0, y2025: 0 },
  3192: { y2024: 0, y2025: 0 },
  3193: { y2024: 0, y2025: 0 },
  3194: { y2024: 0, y2025: 0 },
  3195: { y2024: 0, y2025: 0 },
  3197: { y2024: 0, y2025: 0 },
  3198: { y2024: 0, y2025: 0 },
  3199: { y2024: 0, y2025: 0 },
  3200: { y2024: 0, y2025: 0 },
  3201: { y2024: 0, y2025: 0 },
  3202: { y2024: 0, y2025: 0 },
  3203: { y2024: 0, y2025: 0 },
  3204: { y2024: 0, y2025: 0 },
  3205: { y2024: 0, y2025: 0 },
  3206: { y2024: 0, y2025: 0 },
  3207: { y2024: 0, y2025: 0 },
  3209: { y2024: 0, y2025: 0 },
  3210: { y2024: 0, y2025: 0 },
  3211: { y2024: 0, y2025: 0 },
  3212: { y2024: 0, y2025: 0 },
  3213: { y2024: 0, y2025: 0 },
  3214: { y2024: 0, y2025: 0 },
  3215: { y2024: 0, y2025: 0 },
  3216: { y2024: 0, y2025: 0 },
  3217: { y2024: 0, y2025: 0 },
  3218: { y2024: 0, y2025: 0 },
  3219: { y2024: 0, y2025: 0 },
  3220: { y2024: 0, y2025: 0 },
  3221: { y2024: 0, y2025: 0 },
  3222: { y2024: 0, y2025: 0 },
  3223: { y2024: 0, y2025: 0 },
  3224: { y2024: 0, y2025: 0 },
  3225: { y2024: 0, y2025: 0 },
  3226: { y2024: 0, y2025: 0 },
  3227: { y2024: 0, y2025: 0 },
  3228: { y2024: 0, y2025: 0 },
  3230: { y2024: 0, y2025: 0 },
  3231: { y2024: 0, y2025: 0 },
  3232: { y2024: 3, y2025: 2 },
  3233: { y2024: 0, y2025: 0 },
  3234: { y2024: 0, y2025: 0 },
  3235: { y2024: 0, y2025: 0 },
  3236: { y2024: 0, y2025: 0 },
  3237: { y2024: 0, y2025: 0 },
  3238: { y2024: 0, y2025: 0 },
  3239: { y2024: 0, y2025: 0 },
  3240: { y2024: 0, y2025: 0 },
  3241: { y2024: 0, y2025: 0 },
  3242: { y2024: 0, y2025: 0 },
  3243: { y2024: 0, y2025: 0 },
  3244: { y2024: 0, y2025: 0 },
  3245: { y2024: 0, y2025: 0 },
  3246: { y2024: 0, y2025: 0 },
  3247: { y2024: 0, y2025: 0 },
  3248: { y2024: 0, y2025: 0 },
  3249: { y2024: 7, y2025: 9 },
  3250: { y2024: 0, y2025: 0 },
  3251: { y2024: 0, y2025: 0 },
  3252: { y2024: 0, y2025: 0 },
  3253: { y2024: 0, y2025: 0 },
  3254: { y2024: 0, y2025: 0 },
  3255: { y2024: 0, y2025: 0 },
  3256: { y2024: 0, y2025: 0 },
  3257: { y2024: 5, y2025: 5 },
  3259: { y2024: 0, y2025: 0 },
  3260: { y2024: 0, y2025: 0 },
  3261: { y2024: 0, y2025: 0 },
  3262: { y2024: 0, y2025: 0 },
  3263: { y2024: 0, y2025: 0 },
  3264: { y2024: 0, y2025: 0 },
  3265: { y2024: 0, y2025: 0 },
  3266: { y2024: 0, y2025: 0 },
  3267: { y2024: 0, y2025: 0 },
  3269: { y2024: 0, y2025: 0 },
  3270: { y2024: 0, y2025: 0 },
  3271: { y2024: 0, y2025: 0 },
  3273: { y2024: 0, y2025: 0 },
  3274: { y2024: 0, y2025: 0 },
  3275: { y2024: 0, y2025: 0 },
  3276: { y2024: 0, y2025: 0 },
  3277: { y2024: 0, y2025: 0 },
  3278: { y2024: 0, y2025: 0 },
  3279: { y2024: 0, y2025: 0 },
  3280: { y2024: 0, y2025: 0 },
  3281: { y2024: 0, y2025: 0 },
  3282: { y2024: 0, y2025: 0 },
  3283: { y2024: 0, y2025: 0 },
  3284: { y2024: 0, y2025: 0 },
  3285: { y2024: 0, y2025: 0 },
  3286: { y2024: 0, y2025: 0 },
  3287: { y2024: 0, y2025: 0 },
  3288: { y2024: 0, y2025: 0 },
  3289: { y2024: 0, y2025: 0 },
  3290: { y2024: 0, y2025: 0 },
  3291: { y2024: 0, y2025: 0 },
  3292: { y2024: 0, y2025: 0 },
  3293: { y2024: 0, y2025: 0 },
  3294: { y2024: 0, y2025: 0 },
  3295: { y2024: 0, y2025: 0 },
  3296: { y2024: 0, y2025: 0 },
  3297: { y2024: 0, y2025: 0 },
  3298: { y2024: 0, y2025: 0 },
  3299: { y2024: 0, y2025: 0 },
  3300: { y2024: 0, y2025: 0 },
  3301: { y2024: 0, y2025: 0 },
  3302: { y2024: 0, y2025: 0 },
  3303: { y2024: 0, y2025: 0 },
  3304: { y2024: 0, y2025: 0 },
  3305: { y2024: 0, y2025: 0 },
  3307: { y2024: 0, y2025: 0 },
  3308: { y2024: 0, y2025: 0 },
  3309: { y2024: 4, y2025: 4 },
  3310: { y2024: 0, y2025: 0 },
  3311: { y2024: 0, y2025: 0 },
  3312: { y2024: 0, y2025: 0 },
  3313: { y2024: 0, y2025: 0 },
  3314: { y2024: 0, y2025: 0 },
  3315: { y2024: 0, y2025: 0 },
  3316: { y2024: 0, y2025: 0 },
  3317: { y2024: 0, y2025: 0 },
  3319: { y2024: 0, y2025: 0 },
  3320: { y2024: 0, y2025: 0 },
  3322: { y2024: 0, y2025: 0 },
  3323: { y2024: 0, y2025: 0 },
  3324: { y2024: 0, y2025: 0 },
  3325: { y2024: 0, y2025: 0 },
  3326: { y2024: 10, y2025: 10 },
  3327: { y2024: 0, y2025: 0 },
  3328: { y2024: 0, y2025: 0 },
  3329: { y2024: 0, y2025: 0 },
  3330: { y2024: 0, y2025: 0 },
  3331: { y2024: 0, y2025: 0 },
  3332: { y2024: 0, y2025: 0 },
  3333: { y2024: 0, y2025: 0 },
  3334: { y2024: 6, y2025: 6 },
  3335: { y2024: 0, y2025: 0 },
  3336: { y2024: 0, y2025: 0 },
  3337: { y2024: 0, y2025: 0 },
  3338: { y2024: 0, y2025: 0 },
  3339: { y2024: 0, y2025: 0 },
  3340: { y2024: 5, y2025: 6 },
  3341: { y2024: 0, y2025: 0 },
  3342: { y2024: 0, y2025: 0 },
  3343: { y2024: 0, y2025: 0 },
  3344: { y2024: 0, y2025: 0 },
  3346: { y2024: 0, y2025: 0 },
  3347: { y2024: 0, y2025: 0 },
  3348: { y2024: 0, y2025: 0 },
  3349: { y2024: 0, y2025: 0 },
  3350: { y2024: 0, y2025: 0 },
  3351: { y2024: 0, y2025: 0 },
  3352: { y2024: 0, y2025: 13 },
  3353: { y2024: 0, y2025: 0 },
  3355: { y2024: 0, y2025: 0 },
  3356: { y2024: 0, y2025: 0 },
  3357: { y2024: 0, y2025: 0 },
  3358: { y2024: 0, y2025: 0 },
  3360: { y2024: 0, y2025: 0 },
  3361: { y2024: 0, y2025: 0 },
  3363: { y2024: 0, y2025: 7 },
  3365: { y2024: 0, y2025: 0 },
  3366: { y2024: 0, y2025: 0 },
  3367: { y2024: 0, y2025: 0 },
  3368: { y2024: 0, y2025: 0 },
  3369: { y2024: 0, y2025: 0 },
  3370: { y2024: 8, y2025: 6 },
  3371: { y2024: 0, y2025: 0 },
  3372: { y2024: 0, y2025: 0 },
  3373: { y2024: 0, y2025: 0 },
  3374: { y2024: 0, y2025: 0 },
  3375: { y2024: 0, y2025: 0 },
  3377: { y2024: 0, y2025: 0 },
  3378: { y2024: 0, y2025: 7 },
  3379: { y2024: 0, y2025: 7 },
  3431: { y2024: 0, y2025: 8 },
  3432: { y2024: 0, y2025: 5 },
  3433: { y2024: 0, y2025: 9 },
  3434: { y2024: 0, y2025: 9 },
  3435: { y2024: 0, y2025: 5 },
  3436: { y2024: 0, y2025: 3 },
  3437: { y2024: 0, y2025: 13 },
  3438: { y2024: 0, y2025: 1 },
  3439: { y2024: 0, y2025: 1 },
  3441: { y2024: 0, y2025: 13 },
  3442: { y2024: 0, y2025: 3 },
  3443: { y2024: 0, y2025: 6 },
  3444: { y2024: 0, y2025: 9 },
  3445: { y2024: 0, y2025: 7 },
  3446: { y2024: 0, y2025: 6 },
  3448: { y2024: 0, y2025: 3 },
  3450: { y2024: 0, y2025: 4 },
  3451: { y2024: 0, y2025: 1 },
  3452: { y2024: 0, y2025: 1 },
  3453: { y2024: 0, y2025: 2 },
  3454: { y2024: 0, y2025: 5 },
  3455: { y2024: 0, y2025: 10 },
  3457: { y2024: 0, y2025: 9 },
  3458: { y2024: 7, y2025: 1 },
  3459: { y2024: 0, y2025: 10 },
  3460: { y2024: 11, y2025: 9 },
  3462: { y2024: 0, y2025: 8 },
  3463: { y2024: 0, y2025: 8 },
  3464: { y2024: 0, y2025: 8 },
  3465: { y2024: 0, y2025: 13 },
  3466: { y2024: 0, y2025: 1 },
  3467: { y2024: 0, y2025: 1 },
  3468: { y2024: 0, y2025: 3 },
  3469: { y2024: 0, y2025: 8 },
  3470: { y2024: 0, y2025: 8 },
  3471: { y2024: 0, y2025: 13 },
  3472: { y2024: 0, y2025: 2 },
  3473: { y2024: 0, y2025: 2 },
  3474: { y2024: 0, y2025: 5 },
  3481: { y2024: 0, y2025: 1 },
  3483: { y2024: 0, y2025: 1 },
  3484: { y2024: 0, y2025: 13 },
  3486: { y2024: 0, y2025: 3 },
  3487: { y2024: 0, y2025: 6 },
  3488: { y2024: 0, y2025: 1 },
  3489: { y2024: 0, y2025: 6 },
  3490: { y2024: 0, y2025: 4 },
  3491: { y2024: 0, y2025: 3 },
  3492: { y2024: 0, y2025: 1 },
  3494: { y2024: 0, y2025: 13 },
  3495: { y2024: 0, y2025: 9 },
  3498: { y2024: 0, y2025: 1 },
  3499: { y2024: 0, y2025: 2 },
  3500: { y2024: 13, y2025: 3 },
  3502: { y2024: 0, y2025: 4 },
  3503: { y2024: 0, y2025: 13 },
  3504: { y2024: 0, y2025: 13 },
  3505: { y2024: 0, y2025: 6 },
  3506: { y2024: 0, y2025: 6 },
  3507: { y2024: 0, y2025: 1 },
  3508: { y2024: 0, y2025: 1 },
  3509: { y2024: 0, y2025: 5 },
  3510: { y2024: 0, y2025: 5 },
  3511: { y2024: 0, y2025: 5 },
  3512: { y2024: 0, y2025: 5 },
  3514: { y2024: 0, y2025: 13 },
  3516: { y2024: 0, y2025: 9 },
  3517: { y2024: 0, y2025: 1 },
  3519: { y2024: 0, y2025: 4 },
  3520: { y2024: 0, y2025: 5 },
  3521: { y2024: 0, y2025: 6 },
  3522: { y2024: 0, y2025: 2 },
  3523: { y2024: 0, y2025: 5 },
  3524: { y2024: 0, y2025: 2 },
  3526: { y2024: 0, y2025: 0 },
  3527: { y2024: 0, y2025: 0 },
  3528: { y2024: 0, y2025: 0 },
  3529: { y2024: 10, y2025: 10 },
  3530: { y2024: 10, y2025: 10 },
  3531: { y2024: 0, y2025: 0 },
  3532: { y2024: 0, y2025: 0 },
  3533: { y2024: 0, y2025: 0 },
  3534: { y2024: 0, y2025: 0 },
  3535: { y2024: 0, y2025: 0 },
  3536: { y2024: 0, y2025: 0 },
  3537: { y2024: 0, y2025: 0 },
  3538: { y2024: 0, y2025: 0 },
  3539: { y2024: 0, y2025: 0 },
  3540: { y2024: 0, y2025: 0 },
  3541: { y2024: 0, y2025: 0 },
  3542: { y2024: 0, y2025: 0 },
  3543: { y2024: 0, y2025: 0 },
  3544: { y2024: 0, y2025: 0 },
  3545: { y2024: 0, y2025: 0 },
  3546: { y2024: 0, y2025: 0 },
  3547: { y2024: 0, y2025: 0 },
  3548: { y2024: 0, y2025: 0 },
  3549: { y2024: 0, y2025: 0 },
  3550: { y2024: 0, y2025: 0 },
  4502: { y2024: 0, y2025: 0 },
  6777: { y2024: 0, y2025: 0 },
  96734: { y2024: 0, y2025: 1 },
  987654: { y2024: 0, y2025: 1 },
  6474738: { y2024: 0, y2025: 0 }
};
